'use client'

import React, { useState, useEffect } from 'react'

import clsx from 'clsx'
import Image from 'next/image'

type CloudflareImage = {
  imageName: string
  cloudflareImageId: string
  width: number
  height: number
}

// Template
// {
//   imageName: '',
//   cloudflareImageId: '',
//   width: 1,
//   height: 1,
// },

const _cloudflareImages: CloudflareImage[] = [
  // product screenshots
  {
    imageName: 'sso_roles_badge',
    cloudflareImageId: 'c4ecba8b-2512-45c0-371f-6e009e14d300',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'data_freshness_row_count',
    cloudflareImageId: '2e4f490f-c763-4f8d-f9bd-6907e871c700',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'storage_more_columns',
    cloudflareImageId: '89b93430-a931-4062-520a-27c1cf32db00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'storageCostsUsageGroups',
    cloudflareImageId: '330c61e1-898d-44ce-e96d-4d3f5113d700',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'readPerformanceStats',
    cloudflareImageId:
      'august-changelog-posts-0-744ddff99d0ca4abf22b8085d216bcad9ee6857dc0141d28cecc028423a1feb8',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'costExplorer1',
    cloudflareImageId:
      'august-changelog-posts-1-b0e9b00ea04f37b8b0f409c0ffcb335b0a2b436639b1eab7016461e6af14d307',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'readWorkloads',
    cloudflareImageId:
      'august-changelog-posts-2-c4f19cb6458d10a3ee72985190f03c5c69f5a973ac2aab0614acdfae9846cdb5',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'columnsAccessedFilter',
    cloudflareImageId:
      'august-changelog-posts-3-319af60e0fda21248c29e2c09179a3439adc62fe86aaa522e3c1a85b2d1bdb97',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'usageGroupSets',
    cloudflareImageId: '7e67a7a1-b16c-498a-4f84-b8cf7c937600',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'usageGroupVersions',
    cloudflareImageId: '8dd1deb3-8ee7-4a50-f21c-f9ec30775400',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'costExplorer2',
    cloudflareImageId:
      'august-changelog-posts-4-575eb249b86f7c4117c09add76da8a0b1c3f0b9a120e8af3c0b734531297fe88',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'SELECTColumnsTab',
    cloudflareImageId:
      'august-changelog-posts-5-0a4e6cfeb50d8fe29ea8cd1846020a8e5cf4c15c41e1f8ab4fbee13b0d7585c1',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'writePerformanceStats',
    cloudflareImageId:
      'august-changelog-posts-6-42ab00bfc8a9205f60ed9958a8849d761f2d277626b85ebb13871c8d381c5b79',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'writeWorkloads',
    cloudflareImageId:
      'august-changelog-posts-7-f2047054c1f0e6ff07099d036b99756d2d94704422711e47d54596b78bc77327',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'allTasks',
    cloudflareImageId: 'cf2f86d9-7244-4854-5232-ed77bd21a200',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'taskRunTimeline',
    cloudflareImageId: '220fdf80-5d7d-4bfc-8f4f-b4038ee6b200',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'sprocRunTimeline',
    cloudflareImageId: '60833b20-f52d-4e3c-e374-42a65a13bb00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'exampleSprask',
    cloudflareImageId: '33e095e0-2ffa-4f73-b8ed-bba61ee8bc00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'allSprocs',
    cloudflareImageId: '31ada12f-0572-44c0-b0d3-cdfa135d0a00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'exampleSproc',
    cloudflareImageId: 'a93052b4-cbc5-4bc8-9baf-9ab7789bb300',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'dynamicTablesAll',
    cloudflareImageId: 'b6b7ee8a-b713-4d70-1cc7-d68c67d41000',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'dynamicTableDetailsOverview',
    cloudflareImageId: '161d1bb6-45c7-4096-acf7-055ea6e65b00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'dynamicTableDetailsRunHistory',
    cloudflareImageId: 'a23c5502-3c4a-45a1-a2a8-463e92b39b00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'automaticClusteringStatus',
    cloudflareImageId: 'e002d33b-c81c-4618-f1ac-c90d548b9300',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'newInsightsOverview',
    cloudflareImageId:
      'changelog-posts-1-a1d6dd0ace41c8df804011cc78bebd2231fe42dbeda403ca0535c7b34c1dbf1f',

    width: 3024,
    height: 1964,
  },
  {
    imageName: 'insightsResourcePage',
    cloudflareImageId:
      'changelog-posts-0-1582c36404ccd71cb1f0fa067e49c2406d6c08545bafd2fd7ed844b6533c267e',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'customWorkloadFields',
    cloudflareImageId: '6e7c35d4-0102-4eb3-149a-8ebd8d59d300',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'customWorkloadsSlice',
    cloudflareImageId: '91a3aa9a-d241-4020-c575-4be74e472000',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'customWorkloadsRunID',
    cloudflareImageId: 'd4831267-98ec-4a2c-1773-927217602300',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'cloudServicesCostDrivers',
    cloudflareImageId:
      'understand-snowflake-cloud-service-cost-drivers-0-3aa32bb5320940935e921f240770a40a5668ece065e7e2bcca1cb02811ee9ce1',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'inviteUser',
    cloudflareImageId: '79296cde-b351-492d-c310-3e1fe9fb2f00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'deleteUser',
    cloudflareImageId: 'bdfcf085-eeb3-418c-daf0-8cbfda548c00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'viewDismissedInsights',
    cloudflareImageId: '1208e70b-1afc-4d82-7426-3c1ee4745e00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'dismissInsightsModal',
    cloudflareImageId: 'fa927239-514e-4015-95c5-3f51d027cd00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'bulkDismissInsights',
    cloudflareImageId: '8a27df0e-a3ea-44a1-947c-da86dda6a900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'userRoleSelection',
    cloudflareImageId: '1aeb38cb-5932-4f9e-3e53-7482ea76a500',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'userSettingsPage',
    cloudflareImageId: 'fd3c1831-3b8e-4c74-63ff-7600fe92aa00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'teamSettingsPage',
    cloudflareImageId: 'f8eeedfa-919b-454d-d8fe-9d1518ad2a00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'editTeam',
    cloudflareImageId: '0b07d33d-8a7a-491f-67b6-fe16da087a00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'addTeamMembers',
    cloudflareImageId: 'abeb089d-5f1b-49ab-4e65-bd7a72f12100',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'teamMonitor',
    cloudflareImageId: 'c700553a-8863-482c-8384-2e863a7dc200',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'clusterStatsExample',
    cloudflareImageId:
      'warehouse-cluster-utilization-metrics-0-ab464f85f6b7e1c59169e4e6fb5b8d52d62fdff00185588e3d2c7485792c60e6',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'lookerEnhancements',
    cloudflareImageId: '11ecf564-c390-4c29-2ca4-07c650919600',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'clusterUtilizationOverview',
    cloudflareImageId:
      'warehouse-cluster-utilization-metrics-1-507577e28ba17c85ea9d9693e52c5db944766fcb030e8f99d3dc64b384c00d31',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'budgets',
    cloudflareImageId:
      'announcing-budgets-0-15f1011ccc0b45f007944fae7b120524949cb38e8b7dc710c4507dc30c7d9c59',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'budgetsUsageGroupsFilter',
    cloudflareImageId:
      'announcing-budgets-3-a38f0eab01dda33656f16d188ec65347cd608ef59435daacff90f4a7aeb591e0',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'budgetsTiles',
    cloudflareImageId:
      'announcing-budgets-4-cff6fe6e888308c240944173b6abb092b228f983d0f1fb86c172e0bef3a8d089',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'organizationCostExplorer1',
    cloudflareImageId: '8f1dc16d-a325-4d02-4447-992efdd3ab00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'organizationCostExplorer2',
    cloudflareImageId: 'ed5f6140-8859-43c5-b2c7-efda39705100',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'queryPatternExample',
    cloudflareImageId: '18a7384b-6013-4bd6-ceb1-57846f0eba00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'customWorkloadExample',
    cloudflareImageId: 'a69a6a8d-28c4-4e96-5f0f-d856d9073700',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'queryPatterns',
    cloudflareImageId: '5f0faa17-1f63-4499-84dd-d109a2d40900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'dbtRunsIntegration',
    cloudflareImageId: '02696bbe-2dea-416c-0cfe-f1c596fdda00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'workloads',
    cloudflareImageId: '6e56ffe9-d474-4a86-4df4-57445bfed000',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'productBannerFeb2025',
    cloudflareImageId: 'ab9d2429-87bd-4b11-4e88-8b86d2076400',
    width: 1910,
    height: 1366,
  },
  {
    imageName: 'usageGroupsFeature',
    cloudflareImageId: '1d5b8d2d-21f7-4c7f-8156-33a1f945e800',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'slackNotification',
    cloudflareImageId: 'fff14c6a-c0d5-4fda-e1fa-17b295c6b500',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'organizationUsageGroups',
    cloudflareImageId: '2d94ff74-fd74-4fd1-b3b5-89a252a66a00',
    width: 3024,
    height: 1964,
  },

  // product screenshots non-standard size
  {
    imageName: 'snowflakeAccountSwitcher',
    cloudflareImageId: 'f316b6c9-9dc1-4919-da3d-2d253173e600',
    width: 1476,
    height: 1016,
  },
  {
    imageName: 'selectAccountSpendThreshold',
    cloudflareImageId: '2527c7e2-4e61-41d6-2673-4a4a321ec100',
    width: 1238,
    height: 1452,
  },
  // dbtThreads
  {
    imageName: 'dbtThreads',
    cloudflareImageId: 'e01b16ad-06a4-4292-72c0-5a3f91582900',
    width: 3024,
    height: 1964,
  },
  // Databricks vs. Snowflake
  {
    imageName: 'create-warehouse-comparisons',
    cloudflareImageId: '0ed07ca9-caa2-41c4-12a9-2c4637e6a900',
    width: 2334,
    height: 1314,
  },
  {
    imageName: 'dbx-snow-timelines',
    cloudflareImageId: '0437adab-21f5-4d0d-3b12-de27056e5200',
    width: 2340,
    height: 1312,
  },
  {
    imageName: 'dbx-snow-pricing-comparison',
    cloudflareImageId: '6225fe71-eff0-4790-8daf-4e7c02dea900',
    width: 2976,
    height: 1404,
  },
  {
    imageName: 'website-snapshots',
    cloudflareImageId: 'ca1c933d-45f1-4964-fb51-c80f67087a00',
    width: 2336,
    height: 1100,
  },
  {
    imageName: 'dbx-snow-market-share',
    cloudflareImageId: '65a4189e-60a4-48de-5bef-1618c3361300',
    width: 2332,
    height: 1302,
  },
  // Event Tables for Structured Logging & Tracing in Snowflake
  {
    imageName:
      'event-tables-for-structured-logging-tracing-in-snowflake-0-ffda6a12c2ee5623d31d0c6963240e5f335b8e5a83d644a51dd0b75a4d924022',
    cloudflareImageId:
      'event-tables-for-structured-logging-tracing-in-snowflake-0-ffda6a12c2ee5623d31d0c6963240e5f335b8e5a83d644a51dd0b75a4d924022',
    width: 1559,
    height: 1372,
  },
  {
    imageName:
      'event-tables-for-structured-logging-tracing-in-snowflake-1-ef38a6f52c135279ffbb98bff3eb8d054018fbfcb141bc6f0be2132e272196d9',
    cloudflareImageId:
      'event-tables-for-structured-logging-tracing-in-snowflake-1-ef38a6f52c135279ffbb98bff3eb8d054018fbfcb141bc6f0be2132e272196d9',
    width: 1982,
    height: 1912,
  },
  {
    imageName:
      'event-tables-for-structured-logging-tracing-in-snowflake-2-c9f7d4ae3e30bc9feb387c7aa3c3019244a456168a6d186154157819de0b7cf5',
    cloudflareImageId:
      'event-tables-for-structured-logging-tracing-in-snowflake-2-c9f7d4ae3e30bc9feb387c7aa3c3019244a456168a6d186154157819de0b7cf5',
    width: 2208,
    height: 432,
  },
  {
    imageName:
      'event-tables-for-structured-logging-tracing-in-snowflake-3-3b99c329f3fa0a62f18b07c8ebb8f71b7f80c9337643fb2ca5b1066f5034625a',
    cloudflareImageId:
      'event-tables-for-structured-logging-tracing-in-snowflake-3-3b99c329f3fa0a62f18b07c8ebb8f71b7f80c9337643fb2ca5b1066f5034625a',
    width: 1989,
    height: 1132,
  },
  // Snowflake Cost Management
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-0-99486493a4dead4ce07ad9b7c5ee98e57eee01aa39fc2221d19a19ae933d0f44',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-0-99486493a4dead4ce07ad9b7c5ee98e57eee01aa39fc2221d19a19ae933d0f44',
    width: 1600,
    height: 3281,
  },
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-1-1a95711712a266db72800c83fc986fcf96c8cce5db09b0efcbc91d4c8078dd72',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-1-1a95711712a266db72800c83fc986fcf96c8cce5db09b0efcbc91d4c8078dd72',
    width: 1280,
    height: 720,
  },
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-2-9726582d3019062027119d9e5bb7b4c059537a8db73e2784abd7ae7e2b3f39fa',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-2-9726582d3019062027119d9e5bb7b4c059537a8db73e2784abd7ae7e2b3f39fa',
    width: 2702,
    height: 1788,
  },
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-3-705111faa489ad74e0d603811039239276c4d2d0f84205b4a96de4f3140c5af6',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-3-705111faa489ad74e0d603811039239276c4d2d0f84205b4a96de4f3140c5af6',
    width: 1238,
    height: 1452,
  },
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-4-5af68fd3285bfc856f888d7a72bac3c51ba54be57319520c90d47e42367c7ac0',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-4-5af68fd3285bfc856f888d7a72bac3c51ba54be57319520c90d47e42367c7ac0',
    width: 2992,
    height: 2062,
  },
  {
    imageName:
      'snowflake-cost-management-insights-from-100-customers-5-0129f03a69c7ceefc4408775c79225c409a847a1849f89f88f324d47739ed5ea',
    cloudflareImageId:
      'snowflake-cost-management-insights-from-100-customers-5-0129f03a69c7ceefc4408775c79225c409a847a1849f89f88f324d47739ed5ea',
    width: 2994,
    height: 2080,
  },

  // SSO Group Docs
  {
    imageName:
      'sso-group-mappings-0-d8ecb062c24e703a588e24f7a24e7d1ccb20363c27ad6cd9af433fb419d57952',
    cloudflareImageId:
      'sso-group-mappings-0-d8ecb062c24e703a588e24f7a24e7d1ccb20363c27ad6cd9af433fb419d57952',
    width: 2626,
    height: 1728,
  },
  {
    imageName:
      'sso-group-mappings-1-b7c9ccfbf4dc872e550b688a753197b22207af4ab3efb373d6da8a7a71cbf32c',
    cloudflareImageId:
      'sso-group-mappings-1-b7c9ccfbf4dc872e550b688a753197b22207af4ab3efb373d6da8a7a71cbf32c',
    width: 2624,
    height: 1718,
  },
  {
    imageName:
      'sso-group-mappings-2-5f3cb51d7bcaedbe1b261625d064aad40ef92322a802907a0535b827e85b29ca',
    cloudflareImageId:
      'sso-group-mappings-2-5f3cb51d7bcaedbe1b261625d064aad40ef92322a802907a0535b827e85b29ca',
    width: 2626,
    height: 1734,
  },
  {
    imageName:
      'sso-group-mappings-3-9160b94f777d2b14899c34531fb2d704eae4e3a409152e90188d164ea450d616',
    cloudflareImageId:
      'sso-group-mappings-3-9160b94f777d2b14899c34531fb2d704eae4e3a409152e90188d164ea450d616',
    width: 2618,
    height: 1722,
  },
  {
    imageName:
      'sso-group-mappings-4-a94c684018cc38af3d0c3fe51eebdbeb9314072a894b2f309fadd52554b119e1',
    cloudflareImageId:
      'sso-group-mappings-4-a94c684018cc38af3d0c3fe51eebdbeb9314072a894b2f309fadd52554b119e1',
    width: 2624,
    height: 1728,
  },
  {
    imageName: 'sso-user-sidebar',
    cloudflareImageId: '230dc412-57fc-4fd5-91b1-1357ec3ddc00',
    width: 1008,
    height: 1126,
  },
  {
    imageName: 'sso-user-roles-empty-state',
    cloudflareImageId: '05b572de-75a7-4c11-2a6b-1f0b77f61e00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'sso-user-roles-adding-mapping',
    cloudflareImageId: '89b73eff-0222-44e6-9992-60187a44c900',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'sso-user-roles-end-state',
    cloudflareImageId: '34bea819-b589-47f3-8c89-2f5766a2f900',
    width: 3456,
    height: 2234,
  },
  // Snowflake Access History
  {
    imageName: 'snowflakeAccessHistoryBaseVsDirect',
    cloudflareImageId:
      'snowflake-access-history-8-ways-to-audit-your-account-0-2b3dec0045b8cf64659df8153ed5cd839307f289c6fab42861030b4d935bdf28',
    width: 3128,
    height: 2669,
  },
  // Snowflake Python Connector
  {
    imageName: 'snowflakePythonConnector',
    cloudflareImageId:
      'up-running-with-the-snowflake-connector-for-python-0-a500eabfadfff1e3efd2fb031237a983fbf337d3b83caab80d8f80ef300d23c4',
    width: 2532,
    height: 971,
  },
  // DATEDIFF
  {
    imageName: 'snowflakeDATEDIFF',
    cloudflareImageId:
      'snowflake-datediff-4-quick-reference-examples-0-0d7aa181a30473d8f597fc1f7f4656e063c6a05e07107e87c06674962b631c4e',
    width: 1908,
    height: 1056,
  },
  // Snowflake logo
  {
    imageName: 'snowflake-brand-assets-location',
    cloudflareImageId: '0e00804b-32ef-4348-8566-c444d367fa00',
    width: 2518,
    height: 1332,
  },
  {
    imageName: 'snowflake-brand-assets-location-v2',
    cloudflareImageId: '18421d6d-d385-4fd0-d1e5-df8d4a3efa00',
    width: 2690,
    height: 2148,
  },
  {
    imageName: 'snowflake-full-logo',
    cloudflareImageId: 'bcb881af-c434-44bd-5772-d63c0e137a00',
    width: 1100,
    height: 848,
  },
  {
    imageName: 'snowflake-bug',
    cloudflareImageId: 'c0fc41e2-e53a-47ef-d487-ce90426ba100',
    width: 690,
    height: 1274,
  },
  {
    imageName: 'snowflake-slides-download',
    cloudflareImageId: '02808264-dda7-472c-f54b-719571550200',
    width: 2836,
    height: 1740,
  },
  {
    imageName: 'snowflake-icons-1',
    cloudflareImageId: '39abd74d-c203-4a32-505a-d93c45007c00',
    width: 3284,
    height: 1852,
  },
  {
    imageName: 'snowflake-icons-2',
    cloudflareImageId: 'ea627e45-1a27-4d00-408d-c85d7fbbf200',
    width: 3284,
    height: 1846,
  },
  {
    imageName: 'snowflake-icons-3',
    cloudflareImageId: '30bc29e1-3e1c-4edd-b232-4527e6844e00',
    width: 3286,
    height: 1850,
  },
  // Snowflake MFA
  {
    imageName:
      'snowflake-mfa-0-eb999c632e20d9f9a894836b7c1b15315ba5b6237b16ec8b8c992f83d850a759',
    cloudflareImageId:
      'snowflake-mfa-0-eb999c632e20d9f9a894836b7c1b15315ba5b6237b16ec8b8c992f83d850a759',
    width: 2352,
    height: 1514,
  },
  {
    imageName:
      'snowflake-mfa-1-086d99204c290ae4c454d67a42b259939f56e43508217259d3b1f763c2583a2e',
    cloudflareImageId:
      'snowflake-mfa-1-086d99204c290ae4c454d67a42b259939f56e43508217259d3b1f763c2583a2e',
    width: 2334,
    height: 1508,
  },
  // roles blog post
  {
    imageName: 'roles1',
    cloudflareImageId: 'cb3af0fc-2372-4deb-1f99-e3640b198f00',
    width: 2140,
    height: 1677,
  },
  {
    imageName: 'roles3',
    cloudflareImageId: '788bc3d9-2a9a-4db8-b75e-a65bd72b6f00',
    width: 4075,
    height: 1400,
  },
  {
    imageName: 'roles7',
    cloudflareImageId: '513978e2-705e-44fa-4460-23d7d47d2d00',
    width: 4180,
    height: 1426,
  },
  {
    imageName: 'roles4',
    cloudflareImageId: '5a5a332e-ae2e-43bc-65ff-ab2aca865600',
    width: 2020,
    height: 1280,
  },
  {
    imageName: 'roles6',
    cloudflareImageId: '52926641-2e2c-4f8a-17e7-6c644c322200',
    width: 2620,
    height: 1252,
  },
  {
    imageName: 'roles0',
    cloudflareImageId: 'a290f475-f6ca-43f7-5277-9cb91511bc00',
    width: 2402,
    height: 1384,
  },
  {
    imageName: 'roles2',
    cloudflareImageId: '45f54149-beee-4274-ada9-1647c4dafc00',
    width: 2380,
    height: 835,
  },
  {
    imageName: 'roles5',
    cloudflareImageId: '1e9dd1e7-5606-4a39-fa02-84433d208400',
    width: 2080,
    height: 982,
  },
  {
    imageName: 'roles8',
    cloudflareImageId: 'c1be5bef-d2f4-4992-c37a-fdacf782bf00',
    width: 3088,
    height: 812,
  },
  {
    imageName: 'roles11',
    cloudflareImageId: 'da9aa790-2d37-420f-5c3b-79d0ffd6f100',
    width: 1672,
    height: 760,
  },
  {
    imageName: 'roles9',
    cloudflareImageId: '33519144-d1b9-42b0-1df5-419f30b91d00',
    width: 2276,
    height: 672,
  },
  {
    imageName: 'roles10',
    cloudflareImageId: '5e358d53-4912-4f46-5f6e-6d987d89fb00',
    width: 1720,
    height: 326,
  },
  // manage users docs
  {
    imageName: 'invite_teammate',
    cloudflareImageId: 'a25f5e88-4128-495e-a88f-488ee82bd700',
    width: 2884,
    height: 1862,
  },
  {
    imageName: 'user_settings',
    cloudflareImageId: '8aa0227c-7ad7-431d-00f3-beb771dd7400',
    width: 2750,
    height: 1508,
  },
  {
    imageName: 'pending_invitation',
    cloudflareImageId: '5a6b83d3-f541-4ffb-f4bd-d2a2c39a9600',
    width: 1658,
    height: 420,
  },
  // budget on monitors
  {
    imageName: 'monitorWithBudget',
    cloudflareImageId: 'c4f937a0-9762-4e25-b0e5-969c114d0900',
    width: 1600,
    height: 3281,
  },
  // email integration changelog post
  {
    imageName: 'monitorEmailIntegration',
    cloudflareImageId: '5b82be1a-45f4-4232-0293-9f99369de200',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'monitorEmailIntegrationExample',
    cloudflareImageId: '23a1042b-d22c-4866-87f4-cdbdabeaff00',
    width: 2091,
    height: 2787,
  },
  // organization monitors changelog post
  {
    imageName: 'average-duration-bi',
    cloudflareImageId: 'afa57fb8-fa86-4b20-cd0a-bf846a1f0f00',
    width: 3024,
    height: 1964,
  },
  // organization monitors changelog post
  {
    imageName: 'organization-monitors',
    cloudflareImageId: 'd06154eb-bc0b-498d-1243-5431ef198700',
    width: 1576,
    height: 1456,
  },
  // multiple destinations changelog post
  {
    imageName: 'monitorsMultipleDestinations',
    cloudflareImageId: '1156b99b-bfd4-4c7d-3b6c-fe6341e49c00',
    width: 3024,
    height: 1964,
  },
  // currency changelog post
  {
    imageName: 'local-currency',
    cloudflareImageId: '79dd8e21-356b-4384-b595-ba5a73201800',
    width: 2870,
    height: 1860,
  },
  // looker table top users
  {
    imageName: 'top-users-looker-csv',
    cloudflareImageId: '11339bd4-c099-4a55-64d3-663a4cdbdf00',
    width: 2730,
    height: 1924,
  },
  {
    imageName: 'top-users-looker',
    cloudflareImageId: '61cee4fb-16a4-4653-2818-dcbd3344a000',
    width: 2722,
    height: 1366,
  },
  // storage top users
  {
    imageName: 'top-users-storage',
    cloudflareImageId: 'ce5e1951-91cd-4de2-6fbb-aa162dc67400',
    width: 2550,
    height: 1600,
  },
  {
    imageName: 'top-users-storage-bi-user',
    cloudflareImageId: '9519aa00-7cd5-44f5-1836-779ca1ec9100',
    width: 2730,
    height: 1928,
  },
  // dbt Runs Chart changelog
  {
    imageName: 'dbt-runs-chart',
    cloudflareImageId: '55bf8e88-a257-4b2d-c8c5-b8819bce8100',
    width: 3452,
    height: 2234,
  },
  // Organization Dashboard Changelog
  {
    imageName: 'multi_account_1_20240220',
    cloudflareImageId: '0c0c0c6d-a309-47c6-fa34-9e889f670200',
    width: 3060,
    height: 1834,
  },
  {
    imageName: 'multi_account_2_20240220',
    cloudflareImageId: '873caadb-1461-4f8f-8893-868a4c140300',
    width: 3058,
    height: 1836,
  },
  // Snowflake Pricing
  {
    imageName: 'snowflake-editions',
    cloudflareImageId: '0b59be6e-8692-4e83-6fd6-301ced8f7700',
    width: 2610,
    height: 1526,
  },
  {
    imageName: 'snowflake-pricing-example',
    cloudflareImageId: '7c34a77b-782a-489e-f8f4-8f9b1918f300',
    width: 1688,
    height: 1112,
  },
  {
    imageName: 'snowflake-overview',
    cloudflareImageId: '0e830c07-51e6-4cbe-b5db-efd0f9939a00',
    width: 2639,
    height: 1615,
  },
  // Query Optimization
  {
    imageName: '1_join_filter',
    cloudflareImageId: 'd7b7c7b4-17c4-4887-38b4-d410fa941100',
    width: 2048,
    height: 676,
  },
  {
    imageName: '2_filter_early_before',
    cloudflareImageId: '8255994a-dcf0-49a8-4aa2-18c82495b600',
    width: 2492,
    height: 2086,
  },
  {
    imageName: '3_filter_early_after',
    cloudflareImageId: '45bf4dc1-847b-4374-3053-8e5d7a3ad500',
    width: 2366,
    height: 2152,
  },
  {
    imageName: '4_unnecessary_sort',
    cloudflareImageId: '26e152fb-8275-48c9-03ce-e1084c738b00',
    width: 1260,
    height: 990,
  },
  {
    imageName: '5_cte_bottleneck',
    cloudflareImageId: 'a6d85bdb-52e4-478a-f7ce-7d877da4c500',
    width: 1493,
    height: 1171,
  },
  {
    imageName: '6_filter_early_query_example',
    cloudflareImageId: '353b308d-b571-4ce0-0d05-419bdf49fc00',
    width: 1272,
    height: 958,
  },
  {
    imageName: '7_avoid_ors',
    cloudflareImageId: '90e1d46b-882a-4709-e946-2414503f9000',
    width: 1396,
    height: 936,
  },
  {
    imageName: '8_complex_view_failing',
    cloudflareImageId: '60c686ad-4760-43ed-c537-32e7fc33c000',
    width: 3434,
    height: 2502,
  },
  {
    imageName: '9_prefer_window_function',
    cloudflareImageId: '7fd47abd-2f58-4564-0d32-2369129b8d00',
    width: 1172,
    height: 972,
  },

  // Cost Optimization
  {
    imageName: '1_warehouse_utilization',
    cloudflareImageId: '3646f4de-92a7-46e1-b2d3-d7da260a2b00',
    width: 2482,
    height: 1648,
  },
  {
    imageName: '2_warehouse_consolidation',
    cloudflareImageId: '0966ccf2-7d79-4d4f-bae8-8779665fc400',
    width: 2712,
    height: 1678,
  },
  {
    imageName: '3_incrementalize',
    cloudflareImageId: '192d0c7e-6dde-40b8-8f32-65dda8872400',
    width: 3050,
    height: 1548,
  },
  {
    imageName: '4_warehouse_sizing',
    cloudflareImageId: 'ec20bbe8-a72a-4dab-f0c0-612b4f4b4c00',
    width: 2374,
    height: 1114,
  },

  // Badges
  {
    imageName: 'snowflakeSelectPartnerBadge',
    cloudflareImageId: 'a168784f-e7fb-4e99-bd79-eaf05ba00f00',
    width: 1024,
    height: 1024,
  },
  {
    imageName: 'soc2Badge',
    cloudflareImageId: 'badges/SOC2.png',
    width: 359,
    height: 357,
  },
  // CTEs
  {
    imageName: 'cte1',
    cloudflareImageId: 'src/images/ctes/1.png',
    width: 851,
    height: 900,
  },
  {
    imageName: 'cte2',
    cloudflareImageId: 'src/images/ctes/2.png',
    width: 1145,
    height: 1214,
  },
  {
    imageName: 'cte3',
    cloudflareImageId: 'src/images/ctes/3.png',
    width: 1149,
    height: 941,
  },
  {
    imageName: 'cte4',
    cloudflareImageId: 'src/images/ctes/4.png',
    width: 1052,
    height: 1273,
  },
  {
    imageName: 'cte5',
    cloudflareImageId: 'src/images/ctes/5.png',
    width: 1004,
    height: 912,
  },
  {
    imageName: 'cte6',
    cloudflareImageId: 'src/images/ctes/6.png',
    width: 1029,
    height: 559,
  },
  {
    imageName: 'cte7',
    cloudflareImageId: 'src/images/ctes/7.png',
    width: 663,
    height: 273,
  },
  {
    imageName: 'cte8',
    cloudflareImageId: 'src/images/ctes/8.png',
    width: 708,
    height: 303,
  },
  {
    imageName: 'cte9',
    cloudflareImageId: 'src/images/ctes/9.png',
    width: 924,
    height: 717,
  },
  {
    imageName: 'cte10',
    cloudflareImageId: 'src/images/ctes/10.png',
    width: 910,
    height: 284,
  },
  {
    imageName: 'cte11',
    cloudflareImageId: 'src/images/ctes/11.png',
    width: 936,
    height: 574,
  },

  // Optimizing Snowflake
  {
    imageName: 'optimizingSnowflakeQueryProfile',
    cloudflareImageId: 'src/images/optimizing-snowflake/query-profile.png',
    width: 1607,
    height: 1190,
  },
  {
    imageName: 'virtualWarehouseConfiguration',
    cloudflareImageId:
      'src/images/optimizing-snowflake/virtual-warehouse-configuration.jpg',
    width: 1736,
    height: 620,
  },
  {
    imageName: 'dataProcessingEfficiency',
    cloudflareImageId:
      'src/images/optimizing-snowflake/data-processing-efficiency.jpg',
    width: 1749,
    height: 1022,
  },

  // And overview of data loading options
  {
    imageName: 'dataLoadingOptions1',
    cloudflareImageId: 'e1e19f61-fb6c-42a5-b53a-c9b233f04100',
    width: 926,
    height: 384,
  },
  {
    imageName: 'dataLoadingOptions2',
    cloudflareImageId: '354f8b5e-cef4-402e-c343-ea7cf6cfa800',
    width: 938,
    height: 334,
  },
  {
    imageName: 'dataLoadingOptions3',
    cloudflareImageId: 'cc3e7201-9325-498e-c1cc-537c95331500',
    width: 882,
    height: 295,
  },
  {
    imageName: 'dataLoadingOptions4',
    cloudflareImageId: '4f681801-de80-411e-c1c4-4ef2f88b0a00',
    width: 1467,
    height: 472,
  },
  {
    imageName: 'dataLoadingOptions5',
    cloudflareImageId: '3ef3d993-a743-4089-7b35-3c16d03d5200',
    width: 800,
    height: 509,
  },
  {
    imageName: 'dataLoadingOptions6',
    cloudflareImageId: 'c1e0fa5b-47db-45fb-a591-fc02a84e8500',
    width: 1229,
    height: 814,
  },

  // Configuring Snowflake Warehouse Sizes in dbt
  {
    imageName: 'dbtCloudWarehouseConfiguration',
    cloudflareImageId:
      'src/images/configuring-snowflake-warehouse-sizes-in-dbt/dbt-cloud-warehouse-configuration.png',
    width: 1658,
    height: 884,
  },

  // Snowflake Warehouse Sizing
  {
    imageName: 'warehouseSizes',
    cloudflareImageId:
      'src/images/snowflake-warehouse-sizing/warehouse-sizes.jpg',
    width: 2552,
    height: 1280,
  },
  {
    imageName: 'queryCostCurve',
    cloudflareImageId:
      'src/images/snowflake-warehouse-sizing/query-cost-curve.jpg',
    width: 2260,
    height: 1254,
  },

  // Snowflake Clustering
  {
    imageName: 'reclustering',
    cloudflareImageId: 'src/images/snowflake-clustering/reclustering.png',
    width: 2392,
    height: 1014,
  },

  // Snowflake Micro Partitions
  {
    imageName: 'anatomyOfAMicroPartition',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/anatomy-of-a-micro-partition.jpg',
    width: 1100,
    height: 663,
  },
  {
    imageName: 'microPartitionMetadata',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/micro-partition-metadata.jpg',
    width: 3056,
    height: 670,
  },
  {
    imageName: 'pruning',
    cloudflareImageId: 'src/images/snowflake-micro-partitions/pruning.jpg',
    width: 1100,
    height: 453,
  },
  {
    imageName: 'snowflakeArchitecture',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/snowflake-architecture.jpg',
    width: 1100,
    height: 841,
  },
  {
    imageName: 'partitionsScannedClassic',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/partitions-scanned-classic.jpg',
    width: 1100,
    height: 540,
  },
  {
    imageName: 'partitionsScannedSnowsight',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/partitions-scanned-snowsight.jpg',
    width: 1100,
    height: 577,
  },
  {
    imageName: 'partitionsScannedSnowsightGood',
    cloudflareImageId:
      'src/images/snowflake-micro-partitions/partitions-scanned-snowsight-good.jpg',
    width: 1100,
    height: 531,
  },

  // Snowflake Architecture Overview
  {
    imageName: 'cloudServices',
    cloudflareImageId: 'src/images/snowflake-architecture/cloud-services.jpg',
    width: 1050,
    height: 389,
  },
  {
    imageName: 'compute',
    cloudflareImageId: 'src/images/snowflake-architecture/compute.jpg',
    width: 1200,
    height: 638,
  },
  {
    imageName: 'storage',
    cloudflareImageId: 'src/images/snowflake-architecture/storage.jpg',
    width: 1050,
    height: 696,
  },
  {
    imageName: 'columnarLayout',
    cloudflareImageId: 'src/images/snowflake-architecture/columnar-layout.jpg',
    width: 2316,
    height: 1010,
  },

  // Cost per query
  {
    imageName: 'costPerQuery1',
    cloudflareImageId: 'src/images/cost-per-query/cost-per-query-1.jpg',
    width: 1884,
    height: 1098,
  },
  {
    imageName: 'costPerQuery2',
    cloudflareImageId: 'src/images/cost-per-query/cost-per-query-2.jpg',
    width: 1982,
    height: 1034,
  },
  {
    imageName: 'costPerQueryAdvanced',
    cloudflareImageId: 'src/images/cost-per-query/cost-per-query-advanced.jpg',
    width: 2004,
    height: 1232,
  },

  // Clustering with materialized views
  {
    imageName: 'materializedViewProfile1',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/materialized-view-profile-1.jpg',
    width: 600,
    height: 530,
  },
  {
    imageName: 'materializedViewProfile2',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/materialized-view-profile-2.jpg',
    width: 600,
    height: 455,
  },
  {
    imageName: 'materializedViewProfile3',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/materialized-view-profile-3.jpg',
    width: 600,
    height: 458,
  },
  {
    imageName: 'multiColumnClusterKeyProfile1',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/multi-column-cluster-key-profile-1.jpg',
    width: 600,
    height: 555,
  },
  {
    imageName: 'multiColumnClusterKeyProfile2',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/multi-column-cluster-key-profile-2.jpg',
    width: 600,
    height: 601,
  },
  {
    imageName: 'multiColumnClusterKeyProfile3',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/multi-column-cluster-key-profile-3.jpg',
    width: 600,
    height: 516,
  },
  {
    imageName: 'multiColumnClusterKey',
    cloudflareImageId:
      'src/images/clustering-with-materialized-views/multi-column-cluster-key.jpg',
    width: 2204,
    height: 982,
  },

  // Security Page
  {
    imageName: 'selectArchitectureSecurity',
    cloudflareImageId: 'src/images/security/select-architecture-security.png',
    width: 1670,
    height: 950,
  },

  // Query Profile
  {
    imageName: 'queryPlan',
    cloudflareImageId: 'src/images/snowflake-query-profile/query-plan.jpg',
    width: 1662,
    height: 216,
  },
  {
    imageName: 'queryProfile',
    cloudflareImageId: 'src/images/snowflake-query-profile/query-profile.jpg',
    width: 600,
    height: 673,
  },
  {
    imageName: 'findQueryProfile1',
    cloudflareImageId:
      'src/images/snowflake-query-profile/find-query-profile-1.jpg',
    width: 1600,
    height: 966,
  },
  {
    imageName: 'findQueryProfile2',
    cloudflareImageId:
      'src/images/snowflake-query-profile/find-query-profile-2.jpg',
    width: 1600,
    height: 1074,
  },
  {
    imageName: 'basicQueryProfile',
    cloudflareImageId:
      'src/images/snowflake-query-profile/basic-query-profile.jpg',
    width: 1600,
    height: 710,
  },
  {
    imageName: 'multiStepQueryProfile',
    cloudflareImageId:
      'src/images/snowflake-query-profile/multi-step-query-profile.jpg',
    width: 1600,
    height: 707,
  },
  {
    imageName: 'basicQueryProfileNodes',
    cloudflareImageId:
      'src/images/snowflake-query-profile/basic-query-profile-nodes.jpg',
    width: 1600,
    height: 1004,
  },
  {
    imageName: 'basicQueryProfileStats',
    cloudflareImageId:
      'src/images/snowflake-query-profile/basic-query-profile-stats.jpg',
    width: 1600,
    height: 991,
  },
  {
    imageName: 'complexQueryProfile',
    cloudflareImageId:
      'src/images/snowflake-query-profile/complex-query-profile.jpg',
    width: 1600,
    height: 1357,
  },
  {
    imageName: 'complexQueryProfileJoinFilter',
    cloudflareImageId:
      'src/images/snowflake-query-profile/complex-query-join-filter.jpg',
    width: 1600,
    height: 1083,
  },
  {
    imageName: 'complexQueryProfileSQL',
    cloudflareImageId:
      'src/images/snowflake-query-profile/complex-query-profile-sql.jpg',
    width: 2066,
    height: 1466,
  },

  // Range Join Optimization
  {
    imageName: 'inputTables',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/input-tables.jpg',
    width: 1300,
    height: 525,
  },
  {
    imageName: 'nonOptimizedRangeJoin',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/non-optimized-range-join.jpg',
    width: 2682,
    height: 1020,
  },
  {
    imageName: 'optimizedRangeJoin',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/optimized-range-join.jpg',
    width: 2028,
    height: 1258,
  },
  {
    imageName: 'queryProfileNoOptimization',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/query-profile-no-optimization.jpg',
    width: 1300,
    height: 967,
  },
  {
    imageName: 'queryProfileWithOptimization',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/query-profile-w-optimization.jpg',
    width: 1300,
    height: 954,
  },
  {
    imageName: 'binSizePerformance',
    cloudflareImageId:
      'src/images/snowflake-range-join-optimization/bin-size-performance.jpg',
    width: 1300,
    height: 794,
  },

  // Resource Monitors
  {
    imageName: 'createResourceMonitor',
    cloudflareImageId:
      'src/images/snowflake-resource-monitors/create_resource_monitor.jpg',
    width: 2864,
    height: 1570,
  },
  {
    imageName: 'emailNotification',
    cloudflareImageId:
      'src/images/snowflake-resource-monitors/email_notification.jpg',
    width: 1170,
    height: 1008,
  },
  {
    imageName: 'showResourceMonitorsSql',
    cloudflareImageId:
      'src/images/snowflake-resource-monitors/show_resource_monitors_sql.jpg',
    width: 2246,
    height: 746,
  },
  {
    imageName: 'showResourceMonitorsUi',
    cloudflareImageId:
      'src/images/snowflake-resource-monitors/show_resource_monitors_ui.jpg',
    width: 2546,
    height: 1202,
  },
  {
    imageName: 'dailyResourceMonitor',
    cloudflareImageId:
      'src/images/snowflake-resource-monitors/snowflake_daily_resource_monitor.jpg',
    width: 1840,
    height: 920,
  },

  // Product Screenshots
  {
    imageName: 'dbtModelOverview',
    cloudflareImageId: 'src/images/product-screenshots/dbt_model_overview.jpg',
    width: 2550,
    height: 2430,
  },
  {
    imageName: 'dbtIntegrationsFeature',
    cloudflareImageId: 'marketing/integrations-feature.png',
    width: 1762,
    height: 1057,
  },
  {
    imageName: 'recommendationsFeature',
    cloudflareImageId: 'marketing/recommendations-feature.png',
    width: 952,
    height: 469,
  },
  {
    imageName: 'queryParser',
    cloudflareImageId: 'marketing/query-parser.png',
    width: 3194,
    height: 1448,
  },
  {
    imageName: 'automatedSavings',
    cloudflareImageId: 'marketing/automated-savings.png',
    width: 2098,
    height: 1050,
  },
  {
    imageName: 'estimatedSavings',
    cloudflareImageId: 'marketing/estimated-savings.png',
    width: 3298,
    height: 1556,
  },

  // Query Timeouts
  {
    imageName: 'queryTimeout',
    cloudflareImageId:
      'src/images/snowflake-query-timeouts/snowflake_query_timeout.jpg',
    width: 1600,
    height: 810,
  },

  // SOC 2 Type 2
  {
    imageName: 'soc2',
    cloudflareImageId: 'public/blog-cards/soc2.jpeg',
    width: 1920,
    height: 1080,
  },

  // Behind the Cape
  {
    imageName: 'behindTheCape',
    cloudflareImageId: 'public/blog-cards/behindTheCape.jpg',
    width: 1200,
    height: 672,
  },
  // Blog - snowpipe
  {
    imageName: '1_snowpipe_overview',
    cloudflareImageId: 'b112e7a2-a062-41a4-1ec3-4a3aa7c49900',
    width: 938,
    height: 334,
  },
  {
    imageName: '2_snowpipe_notification_integration',
    cloudflareImageId: '97bb3a26-1532-4ff1-be6b-2e599463c000',
    width: 1397,
    height: 87,
  },
  {
    imageName: '3_snowpipe_create_event',
    cloudflareImageId: 'f6113852-c1bf-4262-d9bf-018395e81e00',
    width: 833,
    height: 893,
  },
  {
    imageName: '4_snowpipe_destination',
    cloudflareImageId: '7af7982c-1e2f-4494-ef53-85e37abc7200',
    width: 820,
    height: 591,
  },
  {
    imageName: '5_snowpipe_credit_table',
    cloudflareImageId: 'ba8de9ca-4c6e-44bd-01d6-3d538afcde00',
    width: 888,
    height: 1305,
  },
  {
    imageName: '6_snowpipe_query_results',
    cloudflareImageId: '94a70e06-7c92-4a01-f0a9-347ef7055400',
    width: 1365,
    height: 309,
  },
  // Blog - terraform
  {
    imageName: 'terraform_github_actions_workflow',
    cloudflareImageId: '68d29442-3c16-422f-10c7-1877560cc000',
    width: 2860,
    height: 1630,
  },
  {
    imageName: 'terraform_github_actions_architecture',
    cloudflareImageId: '3cff3975-98d8-463f-6de2-0b7e0ae88d00',
    width: 512,
    height: 709,
  },
  {
    imageName: 'terraform_github_actions_secrets',
    cloudflareImageId: '0d4e2574-54a3-4a66-0c77-1509c64a7000',
    width: 1888,
    height: 1412,
  },
  {
    imageName: 'terraform_dbt_airbyte',
    cloudflareImageId: '8a6cda77-8834-447e-21e3-d2b4a8513600',
    width: 1681,
    height: 941,
  },

  // dbt unused models
  {
    imageName: 'sampleDag1',
    cloudflareImageId: 'public/blog-cards/sampleDag1.png',
    width: 1600,
    height: 740,
  },
  {
    imageName: 'sampleDag2',
    cloudflareImageId: 'blog/dbt-unused-models/sampleDag2.png',
    width: 668,
    height: 270,
  },
  {
    imageName: 'dbtDescendants',
    cloudflareImageId: 'blog/dbt-unused-models/dbtDescendants.png',
    width: 544,
    height: 818,
  },

  // Snowflake Batch Data Loading | Best Practices in 2024
  {
    imageName: 'loadingGraph1',
    cloudflareImageId: '277aa0e1-12a2-415d-34b1-ea3bc16b6f00',
    width: 1366,
    height: 619,
  },
  {
    imageName: 'loadingGraph2',
    cloudflareImageId: '2748867a-9d7f-4fb7-9850-61cfd7930c00',
    width: 2976,
    height: 1528,
  },
  {
    imageName: 'fileSizes3',
    cloudflareImageId: 'c1220371-0f5e-40be-c2d7-1c06c46ec500',
    width: 1366,
    height: 290,
  },
  {
    imageName: 'fileSizes2',
    cloudflareImageId: 'b1035bb5-86eb-45ab-e87e-202a54bf8500',
    width: 1366,
    height: 290,
  },
  {
    imageName: 'fileSizes1',
    cloudflareImageId: '1ad540dd-ecc2-4e3e-495e-6540af39c600',
    width: 800,
    height: 638,
  },
  {
    imageName: 'fileFormat',
    cloudflareImageId: '7631dc23-4ac6-40b6-4a55-226bbcba9700',
    width: 508,
    height: 442,
  },
  {
    imageName: 'filePartitioning',
    cloudflareImageId: '0c8ee38e-8345-44dd-3dee-01eb3eb0c800',
    width: 465,
    height: 474,
  },

  // Merges
  {
    imageName: 'mergeOverview',
    cloudflareImageId: 'public/blog-cards/mergeOverview.png',
    width: 1662,
    height: 880,
  },
  {
    imageName: 'mergeQueryPlan1',
    cloudflareImageId: 'blog/snowflake-merges/mergeQueryPlan1.png',
    width: 1120,
    height: 1284,
  },
  {
    imageName: 'mergeQueryPlan2',
    cloudflareImageId: 'blog/snowflake-merges/mergeQueryPlan2.png',
    width: 957,
    height: 1120,
  },

  // Summit 2023
  {
    imageName: 'summit2023',
    cloudflareImageId: 'public/blog-cards/summit2023.jpg',
    width: 1200,
    height: 681,
  },
  {
    imageName: 'budgetsSummit2023',
    cloudflareImageId: 'blog/summit2023/budgets.jpg',
    width: 1500,
    height: 1031,
  },
  {
    imageName: 'documentAI',
    cloudflareImageId: 'blog/summit2023/documentAI.jpg',
    width: 1330,
    height: 848,
  },
  {
    imageName: 'dynamicTablesBenefits',
    cloudflareImageId: 'blog/summit2023/dynamicTablesBenefits.jpg',
    width: 1500,
    height: 1133,
  },
  {
    imageName: 'dynamicTablesGUI',
    cloudflareImageId: 'blog/summit2023/dynamicTablesGUI.jpg',
    width: 1500,
    height: 940,
  },
  {
    imageName: 'hexSCS',
    cloudflareImageId: 'blog/summit2023/hexSCS.jpg',
    width: 1500,
    height: 888,
  },
  {
    imageName: 'managedIceberg1',
    cloudflareImageId: 'blog/summit2023/managedIceberg1.png',
    width: 2190,
    height: 1204,
  },
  {
    imageName: 'managedIceberg2',
    cloudflareImageId: 'blog/summit2023/managedIceberg2.jpg',
    width: 1200,
    height: 810,
  },
  {
    imageName: 'nativeApps',
    cloudflareImageId: 'blog/summit2023/nativeApps.png',
    width: 2000,
    height: 809,
  },
  {
    imageName: 'snowparkContainerServices',
    cloudflareImageId: 'blog/summit2023/snowparkContainerServices.jpg',
    width: 1500,
    height: 651,
  },
  {
    imageName: 'snowpipeStreaming',
    cloudflareImageId: 'blog/summit2023/snowpipeStreaming.png',
    width: 1280,
    height: 608,
  },
  {
    imageName: 'summitPerformanceImprovements',
    cloudflareImageId: 'blog/summit2023/summitPerformanceImprovements.jpg',
    width: 2420,
    height: 1400,
  },

  // Snowflake Tasks
  {
    imageName: 'snowflakeTasks1',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks1.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks2',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks2.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks3',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks3.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks4',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks4.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks5',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks5.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks6',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks6.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks7',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks7.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks8',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks8.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks9',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks9.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks10',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks10.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks11',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks11.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'snowflakeTasks12',
    cloudflareImageId: 'blog/snowflake-tasks/snowflakeTasks12.png',
    width: 1068,
    height: 369,
  },

  // Error Notifications for Tasks
  {
    imageName: 'errorNotificationsForTasks1',
    cloudflareImageId: 'public/blog-cards/errorNotificationsForTasks.png',
    width: 1790,
    height: 830,
  },
  {
    imageName: 'errorNotificationsForTasks2',
    cloudflareImageId: 'blog/error-notifications-for-snowflake-tasks/2.png',
    width: 1068,
    height: 369,
  },
  {
    imageName: 'errorNotificationsForTasks3',
    cloudflareImageId: 'blog/error-notifications-for-snowflake-tasks/3.png',
    width: 1366,
    height: 594,
  },

  // Blog - Storage Costs
  {
    imageName: 'snowflakeStorage1',
    cloudflareImageId: 'blog/snowflake-storage/snowflakeStorage1.png',
    width: 1295,
    height: 1531,
  },
  {
    imageName: 'snowflakeStorage2',
    cloudflareImageId: 'blog/snowflake-storage/snowflakeStorage2.png',
    width: 3002,
    height: 965,
  },
  {
    imageName: 'snowflakeStorage3',
    cloudflareImageId: 'blog/snowflake-storage/snowflakeStorage3.png',
    width: 2154,
    height: 140,
  },
  {
    imageName: 'snowflakeStorage4',
    cloudflareImageId: 'blog/snowflake-storage/snowflakeStorage4.png',
    width: 1903,
    height: 75,
  },

  // Snowflake alerts
  {
    imageName: 'snowflakeAlerts1',
    cloudflareImageId: 'blog/snowflake-alerts/1.png',
    width: 1002,
    height: 172,
  },
  {
    imageName: 'snowflakeAlerts2',
    cloudflareImageId: 'blog/snowflake-alerts/2.png',
    width: 418,
    height: 142,
  },
  {
    imageName: 'snowflakeAlerts3',
    cloudflareImageId: 'blog/snowflake-alerts/3.png',
    width: 1870,
    height: 129,
  },
  {
    imageName: 'snowflakeAlerts4',
    cloudflareImageId: 'blog/snowflake-alerts/4.png',
    width: 1106,
    height: 1056,
  },
  {
    imageName: 'snowflakeAlerts5',
    cloudflareImageId: 'blog/snowflake-alerts/5.png',
    width: 2346,
    height: 472,
  },
  {
    imageName: 'snowflakeAlerts6',
    cloudflareImageId: 'blog/snowflake-alerts/6.png',
    width: 2136,
    height: 836,
  },

  // Changelog
  {
    imageName: 'monitorsPage',
    cloudflareImageId: 'a7dce862-36e8-400c-b5b9-1b87bc585d00',
    width: 2920,
    height: 1746,
  },
  {
    imageName: 'dbtUsageGroupThreshold',
    cloudflareImageId: '60458f08-737c-4d24-9eae-a1dfaa290f00',
    width: 1284,
    height: 1416,
  },
  {
    imageName: 'usageGroupDigest',
    cloudflareImageId: '2b25f42d-0bab-42d0-93f7-375a8ff4ba00',
    width: 1198,
    height: 1426,
  },
  {
    imageName: 'queryAccelerationSupport',
    cloudflareImageId: '6ed5fb35-3007-4ddc-b7f8-b57ba8f04200',
    width: 2592,
    height: 1752,
  },
  {
    imageName: 'dbtTopLevelKeys',
    cloudflareImageId: '0b85fcfa-ea75-41d3-2a3d-d3060606ff00',
    width: 2702,
    height: 1532,
  },
  {
    imageName: 'tableTopWorkloads',
    cloudflareImageId: 'changelog/table_top_workloads_20231217.png',
    width: 2874,
    height: 1650,
  },
  {
    imageName: 'popChanges',
    cloudflareImageId: 'changelog/pop_changes_20231207.png',
    width: 2394,
    height: 994,
  },
  {
    imageName: 'schemaTableSelectors',
    cloudflareImageId: 'changelog/schema_selector_20231222.png',
    width: 2880,
    height: 1916,
  },

  {
    imageName: 'visualBars',
    cloudflareImageId: 'changelog/visual_bars_20231107.png',
    width: 3262,
    height: 2364,
  },
  {
    imageName: 'fivetranMultipleUsers',
    cloudflareImageId: 'changelog/fivetran_multiple_users_20231116.png',
    width: 2558,
    height: 1474,
  },
  {
    imageName: 'lastSyncTime1',
    cloudflareImageId: 'changelog/last_sync_time_1_20231123.png',
    width: 2984,
    height: 2068,
  },
  {
    imageName: 'lastSyncTime2',
    cloudflareImageId: 'changelog/last_sync_time_2_20231123.png',
    width: 863,
    height: 826,
  },
  {
    imageName: 'periscopeDashboard',
    cloudflareImageId: 'changelog/periscope_overview_20231012.png',
    width: 2978,
    height: 1920,
  },
  {
    imageName: 'periscopeOverview',
    cloudflareImageId: 'changelog/periscope_dashboard_20231012.png',
    width: 2974,
    height: 1924,
  },
  {
    imageName: 'cacheUsage',
    cloudflareImageId: 'changelog/cache_usage_20230501.png',
    width: 2366,
    height: 532,
  },
  {
    imageName: 'slackAlert',
    cloudflareImageId: 'changelog/slack_alert_20230315.jpeg',
    width: 1600,
    height: 1769,
  },
  {
    imageName: 'teamsAlert',
    cloudflareImageId: 'changelog/teams_alert_20230813.png',
    width: 1986,
    height: 1934,
  },
  {
    imageName: 'warehousePerformance',
    cloudflareImageId: 'changelog/warehouse_performance_20230414.png',
    width: 1500,
    height: 1149,
  },
  {
    imageName: 'lookerOverview',
    cloudflareImageId: 'changelog/looker_overview_20230508.png',
    width: 2554,
    height: 1932,
  },
  {
    imageName: 'serverlessWorkloads',
    cloudflareImageId: 'changelog/serverless_workloads_20230606.png',
    width: 1592,
    height: 950,
  },
  {
    imageName: 'snowpipeRecommendation',
    cloudflareImageId: 'changelog/snowpipe_recommendation_20230606.png',
    width: 1273,
    height: 818,
  },
  {
    imageName: 'hourlyGranularity',
    cloudflareImageId: 'changelog/hourly_granularity_20230620.png',
    width: 2052,
    height: 610,
  },
  {
    imageName: 'hourlySelector',
    cloudflareImageId: 'changelog/hourly_selector_20230620.png',
    width: 2076,
    height: 916,
  },
  {
    imageName: 'fivetranOverview1',
    cloudflareImageId: 'changelog/fivetran_overview_1_20230718.png',
    width: 2992,
    height: 1732,
  },
  {
    imageName: 'fivetranOverview2',
    cloudflareImageId: 'changelog/fivetran_overview_2_20230718.png',
    width: 2992,
    height: 1732,
  },
  {
    imageName: 'organizationSettings',
    cloudflareImageId: 'changelog/organization_settings_20230705.png',
    width: 2842,
    height: 1784,
  },
  {
    imageName: 'dbtRunsPage',
    cloudflareImageId: 'changelog/dbt_runs_page_20230712.png',
    width: 3140,
    height: 2384,
  },
  {
    imageName: 'costPerExplore',
    cloudflareImageId: 'changelog/cost_per_explore_20230714.png',
    width: 2048,
    height: 1391,
  },
  {
    imageName: 'explorePage1',
    cloudflareImageId: 'changelog/explore_page_1_20230714.png',
    width: 2880,
    height: 2110,
  },
  {
    imageName: 'explorePage2',
    cloudflareImageId: 'changelog/explore_page_2_20230714.png',
    width: 2882,
    height: 2114,
  },
  {
    imageName: 'incompleteDays',
    cloudflareImageId: 'changelog/incomplete_days_20230718.png',
    width: 2304,
    height: 992,
  },
  {
    imageName: 'incompleteDaysSettings',
    cloudflareImageId: 'changelog/incomplete_days_settings_20230718.png',
    width: 2492,
    height: 932,
  },
  {
    imageName: 'workloadPctTotal',
    cloudflareImageId: 'changelog/workload_pct_total_20230720.png',
    width: 3136,
    height: 2112,
  },
  {
    imageName: 'hideUnusedTabs1',
    cloudflareImageId: 'changelog/hide_unused_tabs_1_20230724.png',
    width: 2698,
    height: 1286,
  },
  {
    imageName: 'hideUnusedTabs2',
    cloudflareImageId: 'changelog/hide_unused_tabs_2_20230724.png',
    width: 2992,
    height: 1332,
  },
  {
    imageName: 'contractOverview',
    cloudflareImageId: 'changelog/contract_overview_20230802.png',
    width: 2048,
    height: 1377,
  },
  {
    imageName: 'warehousesChartAndExtraColumns',
    cloudflareImageId:
      'changelog/warehouses_chart_and_extra_columns_20230901.png',
    width: 3292,
    height: 1866,
  },
  {
    imageName: 'modeTimelineView',
    cloudflareImageId: 'changelog/mode_timeline_view_20230911.png',
    width: 2974,
    height: 2218,
  },
  {
    imageName: 'modeRunHistory',
    cloudflareImageId: 'changelog/mode_run_history_20230911.png',
    width: 3732,
    height: 2218,
  },
  {
    imageName: 'hex',
    cloudflareImageId: '51679f4c-cab2-4e12-c723-f6aa271c3700',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'hexProject',
    cloudflareImageId: 'e66625db-9522-4cd2-e3c8-ad9b695b6400',
    width: 3456,
    height: 2234,
  },

  // Docs - Account Setup
  {
    imageName: 'findingAccountIdentifier',
    cloudflareImageId: '3bac5830-eaae-4cf1-7e59-b8bf8f772400',
    width: 1490,
    height: 510,
  },
  {
    imageName: 'datashareSpendByService',
    cloudflareImageId: 'adfdb401-afe4-4c3f-3af0-4909db5f8b00',
    width: 2598,
    height: 1954,
  },

  // Docs - Insights
  {
    imageName: 'insights1',
    cloudflareImageId: 'docs/insights1.png',
    width: 3138,
    height: 2028,
  },
  {
    imageName: 'insights2',
    cloudflareImageId: 'docs/insights2.png',
    width: 3138,
    height: 2028,
  },
  {
    imageName: 'insights3',
    cloudflareImageId: 'docs/insights3.png',
    width: 3138,
    height: 2028,
  },
  {
    imageName: 'insights4',
    cloudflareImageId: 'docs/insights4.png',
    width: 3138,
    height: 2028,
  },

  // Docs - Views
  {
    imageName: 'saveView1',
    cloudflareImageId: 'docs/saveView1.png',
    width: 2660,
    height: 1144,
  },
  {
    imageName: 'saveView2',
    cloudflareImageId: 'docs/saveView2.png',
    width: 3114,
    height: 1834,
  },
  {
    imageName: 'manageViews1',
    cloudflareImageId: 'docs/manageViews1.png',
    width: 1932,
    height: 742,
  },
  {
    imageName: 'manageViews2',
    cloudflareImageId: 'docs/manageViews2.png',
    width: 3114,
    height: 1824,
  },
  {
    imageName: 'updateExistingView',
    cloudflareImageId: 'docs/updateExistingView.png',
    width: 3122,
    height: 1836,
  },

  // Docs - Fivetran
  {
    imageName: 'fivetranSetup',
    cloudflareImageId: 'docs/fivetran_settings.png',
    width: 2302,
    height: 866,
  },

  // Docs - Data Sharing
  {
    imageName: 'dataShare1',
    cloudflareImageId: 'docs/dataShare1.png',
    width: 2030,
    height: 384,
  },

  // Docs - Periscope
  {
    imageName: 'periscopeSettings',
    cloudflareImageId: 'docs/periscope_settings.png',
    width: 2454,
    height: 1314,
  },

  // Docs - Teams
  {
    imageName: 'teamsTestMessage',
    cloudflareImageId: 'docs/teamsTestMessage.png',
    width: 1850,
    height: 400,
  },

  // Docs - Mode
  {
    imageName: 'modeAPITokenSetup1',
    cloudflareImageId: 'docs/modeAPITokenSetup1.png',
    width: 1856,
    height: 1378,
  },
  {
    imageName: 'modeAPITokenSetup2',
    cloudflareImageId: 'docs/modeAPITokenSetup2.png',
    width: 2584,
    height: 1712,
  },
  {
    imageName: 'modeAPITokenSetup3',
    cloudflareImageId: 'docs/modeAPITokenSetup3.png',
    width: 2586,
    height: 1586,
  },
  {
    imageName: 'modeAPITokenSetup4',
    cloudflareImageId: 'docs/modeAPITokenSetup4.png',
    width: 2558,
    height: 1742,
  },

  // Docs - Usage Groups
  {
    imageName: 'usageGroups',
    cloudflareImageId: 'd292cea0-dd47-48df-aa59-c55a914bda00',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'newUsageGroup',
    cloudflareImageId: '8b888e46-f472-4bea-87fa-b9d88c4f1e00',
    width: 2044,
    height: 390,
  },
  {
    imageName: 'allWorkloadsUsageGroup',
    cloudflareImageId: 'c6a0bd8a-1723-45db-cf62-7634a88b7700',
    width: 3456,
    height: 2234,
  },

  // Docs - Okta SSO
  {
    imageName: 'okta1',
    cloudflareImageId: 'docs/okta1.png',
    width: 2640,
    height: 1206,
  },
  {
    imageName: 'okta2',
    cloudflareImageId: 'docs/okta2.png',
    width: 1980,
    height: 1748,
  },
  {
    imageName: 'okta3',
    cloudflareImageId: 'docs/okta3.png',
    width: 1280,
    height: 1984,
  },
  {
    imageName: 'okta4',
    cloudflareImageId: 'docs/okta4.png',
    width: 1506,
    height: 1598,
  },
  {
    imageName: 'okta5',
    cloudflareImageId: 'docs/okta5.png',
    width: 1516,
    height: 428,
  },
  {
    imageName: 'okta6',
    cloudflareImageId: 'c342d15f-1f55-4534-03cc-7208308a0700',
    width: 1534,
    height: 1364,
  },
  {
    imageName: 'okta7',
    cloudflareImageId: 'docs/okta7.png',
    width: 592,
    height: 564,
  },

  // Docs - Azure AD SSO
  {
    imageName: 'azure1',
    cloudflareImageId: '3bf0527f-47b5-492d-cc61-c736edb58500',
    width: 3456,
    height: 2158,
  },
  {
    imageName: 'azure2',
    cloudflareImageId: 'b1512e1c-fb01-4de7-3ae0-0d1b96120300',
    width: 3456,
    height: 2159,
  },
  {
    imageName: 'azure3',
    cloudflareImageId: 'd004971d-1219-4a98-749d-752f1805bc00',
    width: 3456,
    height: 2159,
  },
  {
    imageName: 'azure4',
    cloudflareImageId: 'fca00801-9728-4482-8215-1abd4a816b00',
    width: 3456,
    height: 2157,
  },
  {
    imageName: 'azure5',
    cloudflareImageId: '6acb22a4-5a9b-46eb-d25c-f05ddbd4e000',
    width: 3456,
    height: 2157,
  },
  {
    imageName: 'azure6',
    cloudflareImageId: 'd5802e4d-c7f2-48e3-6914-b6573a7df000',
    width: 3456,
    height: 2157,
  },
  {
    imageName: 'azure7',
    cloudflareImageId: '08bbc3ea-2b1d-4ca5-1002-eceacf413900',
    width: 3456,
    height: 2159,
  },
  {
    imageName: 'azure8',
    cloudflareImageId: '3ccd8eeb-247a-4ff1-673e-5977db5d4c00',
    width: 3456,
    height: 2158,
  },
  {
    imageName: 'azurePermissions',
    cloudflareImageId: '2d5cae31-239c-4e5c-2890-b1ac1ebd5600',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'azure9',
    cloudflareImageId: '7a11d815-1af3-452d-1907-c1a4709bcc00',
    width: 3456,
    height: 2157,
  },
  {
    imageName: 'azure10',
    cloudflareImageId: '46c0e71f-7270-4bdf-e478-bfc4dcb62000',
    width: 3456,
    height: 2159,
  },

  // Docs - Monitors
  {
    imageName: 'monitorIntegrationsEmpty',
    cloudflareImageId: 'b715b998-9d10-42d2-864e-5176cbb3c900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'monitorDestinationsEmpty',
    cloudflareImageId: 'b557778b-4c3c-4829-bc16-129822cb3b00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'monitorEmailDestination',
    cloudflareImageId: 'c5cbd8ff-e367-4dff-609a-dc480eb1cd00',
    width: 1532,
    height: 694,
  },
  {
    imageName: 'monitorSlackDestination',
    cloudflareImageId: 'ad9408ba-62d3-4018-dd87-8cbcc5848600',
    width: 1530,
    height: 680,
  },
  {
    imageName: 'monitorTeamsDestination',
    cloudflareImageId: '50147c2a-c22c-492d-bb3b-2f351d6d0000',
    width: 1576,
    height: 898,
  },
  {
    imageName: 'monitorSlackPrivateChannel',
    cloudflareImageId: '1e6d0350-0a8d-40e6-8bb4-56b2309cbf00',
    width: 1512,
    height: 738,
  },
  {
    imageName: 'monitorExamples',
    cloudflareImageId: 'd5a6c820-cfb9-4716-4fae-b07e59a7f600',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'monitorThreshold',
    cloudflareImageId: 'f400e71b-f19e-44e8-0226-5bf3601f1d00',
    width: 3024,
    height: 1964,
  },

  // Docs - Meta Keys Settings

  {
    imageName: 'dbtMetaKeysSettings',
    cloudflareImageId: 'docs/dbtMetaKeysSettings.png',
    width: 2698,
    height: 1930,
  },
  {
    imageName: 'customWorkloadsMetaKeys',
    cloudflareImageId: 'docs/customWorkloadsMetaKeys.png',
    width: 2698,
    height: 1930,
  },
  // Docs - Looker
  {
    imageName: 'lookerDashboard',
    cloudflareImageId: 'docs/looker.png',
    width: 2048,
    height: 1393,
  },
  {
    imageName: 'lookerCreateUser',
    cloudflareImageId: 'src/images/setup-guide/looker-create-user.png',
    width: 2904,
    height: 1796,
  },
  {
    imageName: 'lookerCreateApiKeys',
    cloudflareImageId: 'src/images/setup-guide/looker-create-api-keys.png',
    width: 3044,
    height: 1820,
  },
  {
    imageName: 'lookerCreatePermissionSet',
    cloudflareImageId:
      'src/images/setup-guide/looker-create-permission-set.png',
    width: 3052,
    height: 1196,
  },
  {
    imageName: 'lookerSeeSystemActivity',
    cloudflareImageId: 'src/images/setup-guide/looker-see-system-activity.png',
    width: 2888,
    height: 1632,
  },
  {
    imageName: 'lookerCreateRole',
    cloudflareImageId: 'src/images/setup-guide/looker-create-role.png',
    width: 3042,
    height: 1196,
  },
  {
    imageName: 'lookerAssignPermissionSet',
    cloudflareImageId:
      'src/images/setup-guide/looker-assign-permission-set.png',
    width: 3042,
    height: 1388,
  },
  {
    imageName: 'lookerSelectSettings',
    cloudflareImageId: 'src/images/setup-guide/looker-select-settings.png',
    width: 2462,
    height: 1066,
  },
  {
    imageName: 'lookerBaseUrl',
    cloudflareImageId: 'a3c55e38-8b4f-42ab-aec3-8b14fe6fee00',
    width: 1852,
    height: 714,
  },

  // Docs - Slack
  {
    imageName: 'slackInstallPrompt',
    cloudflareImageId: 'docs/slack_install_prompt.jpg',
    width: 1440,
    height: 1158,
  },
  {
    imageName: 'slackSettings',
    cloudflareImageId: 'docs/slack_settings.jpg',
    width: 2544,
    height: 1530,
  },

  // Docs - Connecting Snowflake accounts
  {
    imageName: 'orgadminSupportTicket',
    cloudflareImageId: 'docs/orgadmin_support_ticket.png',
    width: 1132,
    height: 1798,
  },
  {
    imageName: 'enterSnowflakeAccountInfo',
    cloudflareImageId: '1c572aa5-629b-441a-639c-a342c7354400',
    width: 3456,
    height: 2234,
  },
  {
    imageName: 'enableOrgAdmin',
    cloudflareImageId: 'b6798666-9913-4656-f7d7-f9d4216aee00',
    width: 2854,
    height: 1790,
  },
  {
    imageName: 'addAccountSQLTooltip',
    cloudflareImageId: '6ac7a0d5-5316-41cc-c47f-ae9d738f6100',
    width: 2006,
    height: 952,
  },

  // Docs - Semi Structured Data & JSON Data Parsing
  {
    imageName: 'parse_json_output',
    cloudflareImageId: 'a39ac555-d7d0-4531-56f7-951cb3517300',
    width: 2360,
    height: 1488,
  },
  {
    imageName: 'semi_data_loading',
    cloudflareImageId: 'bb2cead6-8440-4040-efea-111961135400',
    width: 1512,
    height: 1686,
  },
  {
    imageName: 'json_sample_data_example',
    cloudflareImageId: '08947399-6533-4f68-e111-7c6e1ddebc00',
    width: 1286,
    height: 1006,
  },
  {
    imageName: 'try_parse_json_output_2',
    cloudflareImageId: 'bafb5dd3-04c4-4922-1622-900dc21b4000',
    width: 2356,
    height: 1302,
  },
  {
    imageName: 'try_parse_json_output_1',
    cloudflareImageId: 'bd0f88ef-93a6-4259-1ca8-974a0005dd00',
    width: 2354,
    height: 1506,
  },
  {
    imageName: 'parse_json_failing',
    cloudflareImageId: '4d4d3133-d2b9-4679-2f4b-d663b249f300',
    width: 2364,
    height: 1276,
  },
  {
    imageName: 'json_notation',
    cloudflareImageId: '060e3e8d-2b63-43f8-3a4c-82c551e26700',
    width: 2566,
    height: 972,
  },
  {
    imageName: 'casted_lateral_flatten_output',
    cloudflareImageId: 'c8e504d9-ebe7-4d15-d304-48403a41bc00',
    width: 2012,
    height: 694,
  },
  {
    imageName: 'lateral_flatten_output',
    cloudflareImageId: 'f3de33e0-29e5-4ed5-f08e-576abc5e4e00',
    width: 2024,
    height: 614,
  },
  // Summit 2024 Posts
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-0-18e8b3687432f1b8a4c9912ec9a64809ad746c6684c0f654f26352fae4843eb6',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-0-18e8b3687432f1b8a4c9912ec9a64809ad746c6684c0f654f26352fae4843eb6',
    width: 2400,
    height: 1372,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-1-f04bbf0a16711db469f4ccf8d5972d0233f9cd17c96d9b07cabe5660df7c29e7',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-1-f04bbf0a16711db469f4ccf8d5972d0233f9cd17c96d9b07cabe5660df7c29e7',
    width: 2776,
    height: 2787,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-2-896ef060d706bd0ea33f62103866a3cbcaf711c30038ace7da8f2373f51a3636',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-2-896ef060d706bd0ea33f62103866a3cbcaf711c30038ace7da8f2373f51a3636',
    width: 2815,
    height: 2436,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-3-f03adc9e0674bc26f79c9d6dc6a5112591fb2b4f4bddea596948766a230928a7',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-3-f03adc9e0674bc26f79c9d6dc6a5112591fb2b4f4bddea596948766a230928a7',
    width: 952,
    height: 541,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-4-f402e68364eb0ab8c2fae56dfdf73add0d434170a9f25b7d1dc110a3faf66564',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-4-f402e68364eb0ab8c2fae56dfdf73add0d434170a9f25b7d1dc110a3faf66564',
    width: 1976,
    height: 1304,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-5-fef37012569d60bc66da8d86b586a52b4f1e6665749075cc1076e6fde01361fe',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-5-fef37012569d60bc66da8d86b586a52b4f1e6665749075cc1076e6fde01361fe',
    width: 1462,
    height: 1158,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-6-5181218d078de74e5c4147086acf5fdf8526b73d08bd9778fd7c8cafed5fcdb5',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-6-5181218d078de74e5c4147086acf5fdf8526b73d08bd9778fd7c8cafed5fcdb5',
    width: 4032,
    height: 3024,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-7-ad35dbf51f323b28e787fa68668640d2a91ba65119f5fa8ad43c5f026fcd6759',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-7-ad35dbf51f323b28e787fa68668640d2a91ba65119f5fa8ad43c5f026fcd6759',
    width: 1579,
    height: 1148,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-8-38121ad26002c64c7d6c20a061734645865c17769090d5aa4d613d2434f2a6b9',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-8-38121ad26002c64c7d6c20a061734645865c17769090d5aa4d613d2434f2a6b9',
    width: 2990,
    height: 1952,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-9-fd6f2ee97ce4bd92e11b0b29fc48256e38d8c3a5c46ca4202c64e532f681dd93',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-9-fd6f2ee97ce4bd92e11b0b29fc48256e38d8c3a5c46ca4202c64e532f681dd93',
    width: 3210,
    height: 1234,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-10-4acf27d0acb58cad664cd323d3764b48a7c8f138f04e2d842c9ee382d76db477',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-10-4acf27d0acb58cad664cd323d3764b48a7c8f138f04e2d842c9ee382d76db477',
    width: 3022,
    height: 2082,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-11-65647f85b19d3d2c22e288738f932c49928569383a8585f234d256f920645ba0',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-11-65647f85b19d3d2c22e288738f932c49928569383a8585f234d256f920645ba0',
    width: 3106,
    height: 1483,
  },
  {
    imageName:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-12-922309467f91439c819e60582b816f735005b43e6fb41be75b11226f7eab9a04',
    cloudflareImageId:
      'snowflake-summit-2024-all-28-announcements-and-my-takeaways-12-922309467f91439c819e60582b816f735005b43e6fb41be75b11226f7eab9a04',
    width: 918,
    height: 574,
  },
  // May/June Changelog posts
  {
    imageName:
      'changelog-posts-2-28bb59b23322f1c07f032edbce53ab81745207bed9dc04b4b0725dc9d519a6c3',
    cloudflareImageId:
      'changelog-posts-2-28bb59b23322f1c07f032edbce53ab81745207bed9dc04b4b0725dc9d519a6c3',
    width: 3024,
    height: 1964,
  },
  {
    imageName:
      'changelog-posts-3-42abba79101d3cf37a913cbaefabb06aa9b038f715b5029d5dc8e0971dcda221',
    cloudflareImageId:
      'changelog-posts-3-42abba79101d3cf37a913cbaefabb06aa9b038f715b5029d5dc8e0971dcda221',
    width: 3024,
    height: 1964,
  },
  {
    imageName:
      'changelog-posts-4-f6ab77d9941949ca607a4373e64a822a0aaea10ed48e8e8e0d3e4416cce01518',
    cloudflareImageId:
      'changelog-posts-4-f6ab77d9941949ca607a4373e64a822a0aaea10ed48e8e8e0d3e4416cce01518',
    width: 3024,
    height: 1964,
  },
  {
    imageName:
      'changelog-posts-5-0b3136cfea9b7084838484d8f3e5e60ea3c56a229d320820d0f12e554f8716bf',
    cloudflareImageId:
      'changelog-posts-5-0b3136cfea9b7084838484d8f3e5e60ea3c56a229d320820d0f12e554f8716bf',
    width: 3024,
    height: 1964,
  },
  // Snowflake Key Pair Auth
  {
    imageName:
      'snowflake-key-pair-0-297973814bd19736c2f1c771c3b73294c3088feea0712f1b6766f2ddc2e38246',
    cloudflareImageId:
      'snowflake-key-pair-0-297973814bd19736c2f1c771c3b73294c3088feea0712f1b6766f2ddc2e38246',
    width: 3004,
    height: 804,
  },
  {
    imageName:
      'snowflake-key-pair-1-215f40c4280d4352b41f55dae0fac5a2b29a7503e88ee66d73eab5ffea1fd2f4',
    cloudflareImageId:
      'snowflake-key-pair-1-215f40c4280d4352b41f55dae0fac5a2b29a7503e88ee66d73eab5ffea1fd2f4',
    width: 2328,
    height: 2224,
  },
  {
    imageName:
      'snowflake-key-pair-2-8b803a11f68a7dab26d6c6b917258e9ee026ee363c2907296dca9ac463e950b4',
    cloudflareImageId:
      'snowflake-key-pair-2-8b803a11f68a7dab26d6c6b917258e9ee026ee363c2907296dca9ac463e950b4',
    width: 1494,
    height: 668,
  },
  {
    imageName:
      'snowflake-key-pair-3-33e343db6504b711bf7bc7cffd1842425b6a895ae9dfa5f48702a4cfe700dee5',
    cloudflareImageId:
      'snowflake-key-pair-3-33e343db6504b711bf7bc7cffd1842425b6a895ae9dfa5f48702a4cfe700dee5',
    width: 1750,
    height: 350,
  },
  {
    imageName:
      'snowflake-key-pair-4-dd5d8c48250d43a54643fc8854baeade7123d003f204181d17ce63b59e9bc6d3',
    cloudflareImageId:
      'snowflake-key-pair-4-dd5d8c48250d43a54643fc8854baeade7123d003f204181d17ce63b59e9bc6d3',
    width: 1480,
    height: 518,
  },
  {
    imageName:
      'snowflake-key-pair-5-ab97db75650a9064cc2ac73d7c35b92d52947bb48ad6d1b3630cd0643e482567',
    cloudflareImageId:
      'snowflake-key-pair-5-ab97db75650a9064cc2ac73d7c35b92d52947bb48ad6d1b3630cd0643e482567',
    width: 1920,
    height: 1168,
  },
  {
    imageName:
      'snowflake-key-pair-6-626d39bb442a7950d3bda2035419f93c69aa0b3177e76da3620f5aa2c6ff0523',
    cloudflareImageId:
      'snowflake-key-pair-6-626d39bb442a7950d3bda2035419f93c69aa0b3177e76da3620f5aa2c6ff0523',
    width: 1484,
    height: 406,
  },
  // search optimization changelog
  {
    imageName: 'search-optimization',
    cloudflareImageId: 'e09365d4-55ee-473d-869f-d9842724b400',
    width: 3024,
    height: 1964,
  },
  // tasks and stored procedures changelog
  {
    imageName: 'stored-procedures-top-level',
    cloudflareImageId: 'a941e60e-ce6f-47f0-8827-f18069b3c700',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'stored-procedures-workload-level',
    cloudflareImageId: 'b96e6e3f-caf4-45bb-da49-e5348ddbd900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'tasks-workload-level',
    cloudflareImageId: '5a3bd8de-8ab2-4cc1-7cbc-73737cafd700',
    width: 3024,
    height: 1964,
  },

  // Docs - Opsgenie
  {
    imageName: 'opsgenieIntegrationCreated',
    cloudflareImageId: '293db2b4-c778-449e-f30b-4de69ad0b700',
    width: 3024,
    height: 1667,
  },
  {
    imageName: 'opsgenieDestinationCreated',
    cloudflareImageId: '184c2714-e845-4345-6fbb-3825f2cbdd00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'opsgenieMonitor',
    cloudflareImageId: '611dead9-4426-4f40-4900-1d4a7dad9100',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'opsgenieRawMessage',
    cloudflareImageId: 'f4dc4ca3-5caa-4179-a960-fb0b710c2700',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'opsgenieFormattedMessage',
    cloudflareImageId: '79c76998-72ea-4965-2269-c1061a576a00',
    width: 3024,
    height: 1964,
  },

  // dbt threads post
  {
    imageName: 'dbt_model_run_timing_chart',
    cloudflareImageId: '66955772-4fdc-4614-7315-88a662b44c00',
    width: 2526,
    height: 1578,
  },
  {
    imageName: 'snowflake_warehouse_load_history',
    cloudflareImageId: 'eee330f7-70fd-4d19-bb89-02dcd85b9700',
    width: 2966,
    height: 1102,
  },
  {
    imageName: 'query_history_status',
    cloudflareImageId: '2fad8257-1b09-44df-a8b2-f9583ec12c00',
    width: 2976,
    height: 1208,
  },
  // stored procedures blog post
  {
    imageName: 'storedProcs1',
    cloudflareImageId: '23e7d737-d675-4f84-1214-8707295e9a00',
    width: 948,
    height: 485,
  },
  {
    imageName: 'storedProcs1B',
    cloudflareImageId: 'dae039d2-5a89-4aba-19c5-6103a9463600',
    width: 960,
    height: 158,
  },
  {
    imageName: 'storedProcs1C',
    cloudflareImageId: '8b44f32a-a09a-419c-d377-12fb937c4300',
    width: 694,
    height: 159,
  },
  {
    imageName: 'storedProcs2',
    cloudflareImageId: 'b2c84ade-9ea7-4dd0-ed29-e69480babe00',
    width: 1130,
    height: 522,
  },
  {
    imageName: 'storedProcs3',
    cloudflareImageId: 'ddd54c23-089c-496d-cdc9-22ade6a60200',
    width: 955,
    height: 153,
  },
  {
    imageName: 'storedProcs4',
    cloudflareImageId: 'e485c361-1568-46b8-6975-1e6d1da11d00',
    width: 691,
    height: 167,
  },
  {
    imageName: 'storedProcs5',
    cloudflareImageId: '61f2f300-7b6d-46ac-9d7b-190207ceb300',
    width: 693,
    height: 172,
  },
  {
    imageName: 'storedProcs6',
    cloudflareImageId: 'fd897e9c-05be-4654-f148-bede4e200100',
    width: 1710,
    height: 334,
  },
  {
    imageName: 'storedProcs7',
    cloudflareImageId: 'e8296c9e-298c-472e-cfcd-c83c3b443d00',
    width: 1718,
    height: 362,
  },
  {
    imageName: 'storedProcs8',
    cloudflareImageId: '46b73c4c-bc20-4d78-bdb3-80e720f38c00',
    width: 1946,
    height: 238,
  },
  {
    imageName: 'dataFreshness',
    cloudflareImageId: '4f709a63-2014-45e4-8543-9455c663c500',
    width: 1366,
    height: 768,
  },
  {
    imageName: 'dataFreshnessLink',
    cloudflareImageId: 'd624775f-603d-4b9b-9da7-eb5759c13700',
    width: 1366,
    height: 768,
  },
  {
    imageName: 'defaultUserRoles',
    cloudflareImageId: '8378f511-13e3-48d4-d03d-14f471f63a00',
    height: 3024,
    width: 1964,
  },
  // query history blog post
  {
    imageName:
      'using-the-snowflake-query-history-9-practical-examples-0-fc7934ab2d370b4014809fdb901acbffc6e96a73706e80cc15aa2e62a4d4c100',
    cloudflareImageId:
      'using-the-snowflake-query-history-9-practical-examples-0-fc7934ab2d370b4014809fdb901acbffc6e96a73706e80cc15aa2e62a4d4c100',
    width: 2850,
    height: 1664,
  },
  {
    imageName:
      'using-the-snowflake-query-history-9-practical-examples-1-aa11a387b6afbf5404ea0d4c81175cbd8be6303698cc1db6ee9dc42921ff9c93',
    cloudflareImageId:
      'using-the-snowflake-query-history-9-practical-examples-1-aa11a387b6afbf5404ea0d4c81175cbd8be6303698cc1db6ee9dc42921ff9c93',
    width: 2516,
    height: 1294,
  },
  {
    imageName:
      'using-the-snowflake-query-history-9-practical-examples-2-8e8e6376670f53c10fa40a051a7f2a6713300194409a72672df4aaaf5891e646',
    cloudflareImageId:
      'using-the-snowflake-query-history-9-practical-examples-2-8e8e6376670f53c10fa40a051a7f2a6713300194409a72672df4aaaf5891e646',
    width: 2992,
    height: 1722,
  },
  {
    imageName:
      'using-the-snowflake-query-history-9-practical-examples-3-94832512f8e7a760af448b1945a581d40278e5967176067626005c6e2a9e4406',
    cloudflareImageId:
      'using-the-snowflake-query-history-9-practical-examples-3-94832512f8e7a760af448b1945a581d40278e5967176067626005c6e2a9e4406',
    width: 2996,
    height: 1362,
  },
  {
    imageName:
      'using-the-snowflake-query-history-9-practical-examples-4-29940034f8cdd1081d8d9c8de4f00e8f3cb6fa7b3948f2770e119c6cbc5d5141',
    cloudflareImageId:
      'using-the-snowflake-query-history-9-practical-examples-4-29940034f8cdd1081d8d9c8de4f00e8f3cb6fa7b3948f2770e119c6cbc5d5141',
    width: 2992,
    height: 1722,
  },
  {
    imageName: 'tablesAccessed',
    cloudflareImageId: 'c09c37fb-5430-42b7-a8a1-a5b6ee023d00',
    width: 3024,
    height: 1964,
  },
  // Snowflake RBAC Best Practices
  {
    imageName:
      'rbac-best-practices-0-458ec58953079c1ffdb4e21b60772e5b70ed571767a10038ea56ced8cad51f8b',
    cloudflareImageId:
      'rbac-best-practices-0-458ec58953079c1ffdb4e21b60772e5b70ed571767a10038ea56ced8cad51f8b',
    width: 1972,
    height: 366,
  },
  {
    imageName:
      'rbac-best-practices-1-330d0b026dde856b0860cfd054e7c129078cad603ee248c0d9827f92ee6e2e81',
    cloudflareImageId:
      'rbac-best-practices-1-330d0b026dde856b0860cfd054e7c129078cad603ee248c0d9827f92ee6e2e81',
    width: 3440,
    height: 1426,
  },
  {
    imageName:
      'rbac-best-practices-2-805488d364a1be244bc1c7e6a420816c5ceaa3f78343848dc7f0873dcca748c7',
    cloudflareImageId:
      'rbac-best-practices-2-805488d364a1be244bc1c7e6a420816c5ceaa3f78343848dc7f0873dcca748c7',
    width: 1702,
    height: 978,
  },
  {
    imageName:
      'rbac-best-practices-3-321523b5f152c58bd22804364a18efabdab6e052b5f7e4cf48542da79688c943',
    cloudflareImageId:
      'rbac-best-practices-3-321523b5f152c58bd22804364a18efabdab6e052b5f7e4cf48542da79688c943',
    width: 1868,
    height: 788,
  },
  {
    imageName:
      'rbac-best-practices-4-c613679fc0095031eb0d38827326a4b15dda6c3305a8d70df2be7565f46d41c3',
    cloudflareImageId:
      'rbac-best-practices-4-c613679fc0095031eb0d38827326a4b15dda6c3305a8d70df2be7565f46d41c3',
    width: 1612,
    height: 664,
  },
  {
    imageName:
      'rbac-best-practices-5-9bc6cfe70fceef0c7c8ac36be8571415ce5c076b3d8c5e4af95bfa723f1577f5',
    cloudflareImageId:
      'rbac-best-practices-5-9bc6cfe70fceef0c7c8ac36be8571415ce5c076b3d8c5e4af95bfa723f1577f5',
    width: 3506,
    height: 908,
  },
  {
    imageName:
      'rbac-best-practices-6-3ba9114e2320a845a608bf63f3e7e23f7844e7127314c09318ed1bf8f34d5c3d',
    cloudflareImageId:
      'rbac-best-practices-6-3ba9114e2320a845a608bf63f3e7e23f7844e7127314c09318ed1bf8f34d5c3d',
    width: 3506,
    height: 1750,
  },
  {
    imageName:
      'rbac-best-practices-7-c9b5bffbf80960d458e277fbafbfb4e2085a9b3c470a53812d3f69acc10e8b02',
    cloudflareImageId:
      'rbac-best-practices-7-c9b5bffbf80960d458e277fbafbfb4e2085a9b3c470a53812d3f69acc10e8b02',
    width: 2216,
    height: 1220,
  },
  {
    imageName:
      'rbac-best-practices-8-043bd770c98aef58a4b806a3aa87be10ec5e996b4c3d88f3469d73e16eb07c88',
    cloudflareImageId:
      'rbac-best-practices-8-043bd770c98aef58a4b806a3aa87be10ec5e996b4c3d88f3469d73e16eb07c88',
    width: 1716,
    height: 1156,
  },
  {
    imageName:
      'rbac-best-practices-9-08df2e834b62b5d3d231fda08ca25c9871a8b2fc2e5b9369b2d8a59eb1c3f04e',
    cloudflareImageId:
      'rbac-best-practices-9-08df2e834b62b5d3d231fda08ca25c9871a8b2fc2e5b9369b2d8a59eb1c3f04e',
    width: 2648,
    height: 1010,
  },
  {
    imageName:
      'rbac-best-practices-10-bb8543343db96e31f8e57d3b8468914e1048233d6c75ceeec2a87ee515b3c479',
    cloudflareImageId:
      'rbac-best-practices-10-bb8543343db96e31f8e57d3b8468914e1048233d6c75ceeec2a87ee515b3c479',
    width: 1906,
    height: 766,
  },
  {
    imageName:
      'rbac-best-practices-11-88ebf0e591e37e65ba11ef38a16d75be47f11bfed58006069ad61e73301edda1',
    cloudflareImageId:
      'rbac-best-practices-11-88ebf0e591e37e65ba11ef38a16d75be47f11bfed58006069ad61e73301edda1',
    width: 2210,
    height: 648,
  },
  {
    imageName:
      'rbac-best-practices-12-3e1a4e3122ae882220beec5997564d32a33bb080e272cc204a27e2e1619fb461',
    cloudflareImageId:
      'rbac-best-practices-12-3e1a4e3122ae882220beec5997564d32a33bb080e272cc204a27e2e1619fb461',
    width: 2978,
    height: 1742,
  },
  {
    imageName:
      'rbac-best-practices-13-07ee64c783b014e933297c5215c7f034303755ce83db572755439c84f41c32e5',
    cloudflareImageId:
      'rbac-best-practices-13-07ee64c783b014e933297c5215c7f034303755ce83db572755439c84f41c32e5',
    width: 2148,
    height: 476,
  },
  {
    imageName:
      'rbac-best-practices-14-29976c1a935d0b9a1376eb2f6811b1db8ca1f6d6e64354ba3591d927f8a30112',
    cloudflareImageId:
      'rbac-best-practices-14-29976c1a935d0b9a1376eb2f6811b1db8ca1f6d6e64354ba3591d927f8a30112',
    width: 1906,
    height: 670,
  },
  {
    imageName:
      'snowflake-user-types-0-b0ddef0ad7a59bae1e1a2ec7943c2e37b8e4067bab7ba6b66fcb2db9cd990461',
    cloudflareImageId:
      'snowflake-user-types-0-b0ddef0ad7a59bae1e1a2ec7943c2e37b8e4067bab7ba6b66fcb2db9cd990461',
    width: 459,
    height: 326,
  },

  // Snowflake Streams
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-0-0a137457adde0761e6d90c50d4d7e6826b377a4dfc706f0500f99d7a9382699c',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-0-0a137457adde0761e6d90c50d4d7e6826b377a4dfc706f0500f99d7a9382699c',
    width: 1287,
    height: 663,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-1-0ea465db15df0f65515c245dc0897150d66077948d7d2ecc3ed84056469b73b4',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-1-0ea465db15df0f65515c245dc0897150d66077948d7d2ecc3ed84056469b73b4',
    width: 1920,
    height: 1080,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-2-8d122637a510b66c3044967170a44b4ba3794007d0f050d45d6673703ee0dda4',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-2-8d122637a510b66c3044967170a44b4ba3794007d0f050d45d6673703ee0dda4',
    width: 1239,
    height: 299,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-3-3c7e6d17f22d30e4d069cb92b18f3570b60a6a726cd61fe431ef6ee3f3331aed',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-3-3c7e6d17f22d30e4d069cb92b18f3570b60a6a726cd61fe431ef6ee3f3331aed',
    width: 1232,
    height: 239,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-4-065fcf28f935ed3916f6bbf5335e407e40e8646ca11fb3ee1af56d96883a058b',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-4-065fcf28f935ed3916f6bbf5335e407e40e8646ca11fb3ee1af56d96883a058b',
    width: 418,
    height: 384,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-5-17d5c3ea7e375f4b242935d959661deffcea079cac727f9ce31f5a023382afa5',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-5-17d5c3ea7e375f4b242935d959661deffcea079cac727f9ce31f5a023382afa5',
    width: 1763,
    height: 500,
  },
  {
    imageName:
      'using-streams-in-snowflake-for-change-data-capture-6-4e3663dfc896604e5bfcab017e948646bcb75fc1a4e847a791e4c6a345e14816',
    cloudflareImageId:
      'using-streams-in-snowflake-for-change-data-capture-6-4e3663dfc896604e5bfcab017e948646bcb75fc1a4e847a791e4c6a345e14816',
    width: 951,
    height: 253,
  },
  {
    imageName: '7091ab39-da6a-4b24-88cd-a38ce8ce4800',
    cloudflareImageId: '7091ab39-da6a-4b24-88cd-a38ce8ce4800',
    width: 1820,
    height: 864,
  },
  {
    imageName: 'a62a34bf-05de-4940-ed00-1a570bacc300',
    cloudflareImageId: 'a62a34bf-05de-4940-ed00-1a570bacc300',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'a7f2bd2b-729b-4408-b8c9-47e11c019400',
    cloudflareImageId: 'a7f2bd2b-729b-4408-b8c9-47e11c019400',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '1491a468-4071-4e85-8992-2ce9f0fabe00',
    cloudflareImageId: '1491a468-4071-4e85-8992-2ce9f0fabe00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '2bb92d5b-7098-4c61-bb32-f61614927600',
    cloudflareImageId: '2bb92d5b-7098-4c61-bb32-f61614927600',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '7ce13e1b-9ecd-48d5-0edd-ef4ea39a1300',
    cloudflareImageId: '7ce13e1b-9ecd-48d5-0edd-ef4ea39a1300',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '08180c57-6446-429c-d2a8-5928a2580f00',
    cloudflareImageId: '08180c57-6446-429c-d2a8-5928a2580f00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'b724e461-2208-479c-423f-c3d0b60b4300',
    cloudflareImageId: 'b724e461-2208-479c-423f-c3d0b60b4300',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '4cd375d9-3712-4a22-3589-2f4602719c00',
    cloudflareImageId: '4cd375d9-3712-4a22-3589-2f4602719c00',
    width: 676,
    height: 352,
  },
  {
    imageName: '144f8e54-3053-4f57-6538-5f33d55ef200',
    cloudflareImageId: '144f8e54-3053-4f57-6538-5f33d55ef200',
    width: 485,
    height: 258,
  },
  {
    imageName: '4dfbcb12-921f-4517-0b94-2bf0a7c8f800',
    cloudflareImageId: '4dfbcb12-921f-4517-0b94-2bf0a7c8f800',
    width: 193,
    height: 656,
  },
  {
    imageName: 'dc85dfeb-7e8f-401a-80df-fe19bcbb0200',
    cloudflareImageId: 'dc85dfeb-7e8f-401a-80df-fe19bcbb0200',
    width: 480,
    height: 255,
  },
  {
    imageName: 'ee646842-eb45-4b86-6198-2216cedecf00',
    cloudflareImageId: 'ee646842-eb45-4b86-6198-2216cedecf00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'b3a89295-8dab-411d-bbb9-d6706254bb00',
    cloudflareImageId: 'b3a89295-8dab-411d-bbb9-d6706254bb00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '1ae8ed3a-5f35-4719-9aa1-993da1cece00',
    cloudflareImageId: '1ae8ed3a-5f35-4719-9aa1-993da1cece00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '57fe1124-969a-4b91-7c33-f999ee930600',
    cloudflareImageId: '57fe1124-969a-4b91-7c33-f999ee930600',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '2bb8dc62-b31b-4798-6dc9-6bb3288bd300',
    cloudflareImageId: '2bb8dc62-b31b-4798-6dc9-6bb3288bd300',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'd433e7b6-4930-4a03-de2d-55b41e3bf900',
    cloudflareImageId: 'd433e7b6-4930-4a03-de2d-55b41e3bf900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: '83903e4b-642c-46d9-f5de-b3082b43ac00',
    cloudflareImageId: '83903e4b-642c-46d9-f5de-b3082b43ac00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: '7740d550-3a87-4cef-a8bc-880c33296b00',
    cloudflareImageId: '7740d550-3a87-4cef-a8bc-880c33296b00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'd06797bc-d015-4e92-982d-c89755a2cc00',
    cloudflareImageId: 'd06797bc-d015-4e92-982d-c89755a2cc00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'af69f913-cf62-47bd-967d-a5af6af27100',
    cloudflareImageId: 'af69f913-cf62-47bd-967d-a5af6af27100',
    width: 3024,
    height: 1964,
  },
  {
    imageName: '218d87ad-6859-422e-cb0c-6a950bbe5b00',
    cloudflareImageId: '218d87ad-6859-422e-cb0c-6a950bbe5b00',
    width: 3024,
    height: 1964,
  },
  {
    imageName: '49df29d4-584d-4187-5ab5-019eb2c29700',
    cloudflareImageId: '49df29d4-584d-4187-5ab5-019eb2c29700',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '1b1a9ef8-33d1-4eea-b585-3f1222421f00',
    cloudflareImageId: '1b1a9ef8-33d1-4eea-b585-3f1222421f00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '0de2ece4-848f-4435-8260-9420363f9200',
    cloudflareImageId: '0de2ece4-848f-4435-8260-9420363f9200',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '971c4aff-a651-4b3e-5e0c-d6b497fa1700',
    cloudflareImageId: '971c4aff-a651-4b3e-5e0c-d6b497fa1700',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '77837131-03ab-4347-8dff-5b0d82f61700',
    cloudflareImageId: '77837131-03ab-4347-8dff-5b0d82f61700',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '4601b4da-36d2-4d0b-60a3-910fc2ed0700',
    cloudflareImageId: '4601b4da-36d2-4d0b-60a3-910fc2ed0700',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'd71dbfb8-8424-405f-9bcc-f16b16a87900',
    cloudflareImageId: 'd71dbfb8-8424-405f-9bcc-f16b16a87900',
    width: 1530,
    height: 1002,
  },
  {
    imageName: 'ec724c42-a209-48e5-89b9-61e5b5984900',
    cloudflareImageId: 'ec724c42-a209-48e5-89b9-61e5b5984900',
    width: 1280,
    height: 1984,
  },
  {
    imageName: '17ebb209-96d2-4468-b1a3-d557a8e2e500',
    cloudflareImageId: '17ebb209-96d2-4468-b1a3-d557a8e2e500',
    width: 1506,
    height: 1598,
  },
  {
    imageName: 'f7fb11a4-c33c-4bb0-e8e8-2f4fb85ba100',
    cloudflareImageId: 'f7fb11a4-c33c-4bb0-e8e8-2f4fb85ba100',
    width: 240,
    height: 320,
  },
  {
    imageName: 'b1b57bc6-b460-4752-f1d5-b41fb41fb100',
    cloudflareImageId: 'b1b57bc6-b460-4752-f1d5-b41fb41fb100',
    width: 1574,
    height: 259,
  },
  {
    imageName: 'b41a2877-1e2a-4ccc-6dd5-6a3b0c61ae00',
    cloudflareImageId: 'b41a2877-1e2a-4ccc-6dd5-6a3b0c61ae00',
    width: 1084,
    height: 210,
  },
  {
    imageName: '4e238431-bc27-4c33-e63d-1b25bb4c4b00',
    cloudflareImageId: '4e238431-bc27-4c33-e63d-1b25bb4c4b00',
    width: 543,
    height: 230,
  },
  {
    imageName: '832775eb-3db3-470b-6d8e-00e06605fd00',
    cloudflareImageId: '832775eb-3db3-470b-6d8e-00e06605fd00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'e2d84a9b-a3e1-4f93-74d1-154fb2457800',
    cloudflareImageId: 'e2d84a9b-a3e1-4f93-74d1-154fb2457800',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'b62ce5a2-85d0-4368-c530-371357018d00',
    cloudflareImageId: 'b62ce5a2-85d0-4368-c530-371357018d00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'slack1',
    cloudflareImageId: '5071a73f-bd24-466f-fb79-1e5deb0e4a00',
    width: 1107,
    height: 484,
  },
  {
    imageName: 'slack2',
    cloudflareImageId: '5d21871e-6da6-4faf-caee-af73eda27a00',
    width: 520,
    height: 367,
  },
  {
    imageName: 'slack3',
    cloudflareImageId: '82ed7bd0-cdc8-4d62-e2a0-82b7bd20b200',
    width: 523,
    height: 505,
  },
  {
    imageName: 'slack4',
    cloudflareImageId: '04a0765e-b41d-46a3-2ba2-39870daa4e00',
    width: 1006,
    height: 776,
  },
  {
    imageName: 'slack5',
    cloudflareImageId: '01f5b6f0-4adc-4777-6980-def5364c8d00',
    width: 712,
    height: 405,
  },
  {
    imageName: 'slack6',
    cloudflareImageId: 'f0d70a96-7d58-4481-06f3-7532e1a14700',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'slack7',
    cloudflareImageId: '111f7bd8-af7e-443f-80e2-ca21daf71800',
    width: 540,
    height: 496,
  },
  {
    imageName: 'slack8',
    cloudflareImageId: '51f66c46-da62-445e-bf68-99e84fc9c700',
    width: 706,
    height: 431,
  },
  {
    imageName: 'slack9',
    cloudflareImageId: '18f02ff2-7c84-4592-995a-a03dc216f600',
    width: 775,
    height: 639,
  },
  {
    imageName: 'slack10',
    cloudflareImageId: '456a2a1c-a9da-4767-a60c-41c1420fc500',
    width: 511,
    height: 254,
  },
  {
    imageName: 'slack11',
    cloudflareImageId: '8cb43eeb-e96e-4fbf-bc19-4b811c724700',
    width: 446,
    height: 202,
  },
  {
    imageName: 'slack12',
    cloudflareImageId: '958de7cd-5369-490f-2c6e-fab745b44600',
    width: 1283,
    height: 150,
  },
  {
    imageName: 'slack13',
    cloudflareImageId: 'ef0fc162-c722-4f61-c744-5f2955e19700',
    width: 1122,
    height: 54,
  },
  {
    imageName: 'slack14',
    cloudflareImageId: 'dd2ad6e0-ddba-418a-e09d-36f106324300',
    width: 1186,
    height: 211,
  },
  {
    imageName: 'slack15',
    cloudflareImageId: '3c36f2fd-2ab7-4eb5-96d8-67a8661bbe00',
    width: 1123,
    height: 467,
  },
  {
    imageName: 'slack16',
    cloudflareImageId: '49a6aa72-79df-443c-5296-b537bbd9aa00',
    width: 1251,
    height: 923,
  },
  {
    imageName: 'slackcover',
    cloudflareImageId: '6025abdc-14d9-4ce9-3e1a-34ee0ec6b100',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'teams1',
    cloudflareImageId: 'a99da675-6fe3-4560-23f7-73c9a6d4b700',
    width: 195,
    height: 282,
  },
  {
    imageName: 'teams2',
    cloudflareImageId: '04d77fa8-68b7-463a-65e8-5d697c8cd600',
    width: 620,
    height: 482,
  },
  {
    imageName: 'teams3',
    cloudflareImageId: '56691fe9-91ec-4b1e-6222-4ed055525d00',
    width: 579,
    height: 139,
  },
  {
    imageName: 'teams4',
    cloudflareImageId: 'a90c6fcd-1b3b-4f10-d813-5b6ba695e600',
    width: 601,
    height: 679,
  },
  {
    imageName: 'teams5',
    cloudflareImageId: 'f2725547-73b0-4427-0bef-84126b1f4700',
    width: 607,
    height: 429,
  },
  {
    imageName: 'teams6',
    cloudflareImageId: '7cf2d2bc-d81b-4fde-5043-bfba3d875800',
    width: 1002,
    height: 324,
  },
  {
    imageName: 'teams7',
    cloudflareImageId: '563563b1-709f-431c-a81f-395760b61400',
    width: 1029,
    height: 368,
  },
  {
    imageName: 'teams8',
    cloudflareImageId: 'bd30aa03-ad3e-4877-7d92-93d942ec7800',
    width: 1282,
    height: 142,
  },
  {
    imageName: 'teams9',
    cloudflareImageId: 'fdffa481-ae2d-4ae1-54db-97e9e821ba00',
    width: 989,
    height: 358,
  },
  {
    imageName: '7af8279c-4d5b-4c88-d1ab-4a269a978500',
    cloudflareImageId: '7af8279c-4d5b-4c88-d1ab-4a269a978500',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'changeloggregcover',
    cloudflareImageId: 'e2d84a9b-a3e1-4f93-74d1-154fb2457800',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'changeloggregmain',
    cloudflareImageId: '8979fa71-0058-49d1-6961-56d391ecb100',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'dynamictables1',
    cloudflareImageId: 'e1049744-6c5c-4a76-5e9b-2bd3cc515700',
    width: 1391,
    height: 650,
  },
  {
    imageName: 'dynamictables2',
    cloudflareImageId: 'b01b26ff-ee96-4a4f-abb0-e153e2b9b000',
    width: 1316,
    height: 640,
  },
  {
    imageName: 'dynamictables3',
    cloudflareImageId: '4369cacf-b24b-447b-ffc8-fc3301df5200',
    width: 1643,
    height: 831,
  },
  {
    imageName: 'dynamictables4',
    cloudflareImageId: '6123e1bc-b44e-41b4-9436-4e85ba425600',
    width: 1224,
    height: 663,
  },
  {
    imageName: 'dynamictables5',
    cloudflareImageId: 'a2c1e1c6-7c8c-4436-d42e-bd6e779b5800',
    width: 1115,
    height: 266,
  },
  {
    imageName: 'dynamictables6',
    cloudflareImageId: '6fcd3727-aea4-42e2-1376-bbb57d090000',
    width: 1272,
    height: 618,
  },
  {
    imageName: 'dynamictables7',
    cloudflareImageId: 'f92f7e2a-f797-473b-6188-efdd8059a400',
    width: 1266,
    height: 631,
  },
  {
    imageName: 'dynamictables8',
    cloudflareImageId: '7a8899b8-9afe-4ec9-bace-64c61f120600',
    width: 1113,
    height: 366,
  },
  {
    imageName: 'dynamictables9',
    cloudflareImageId: 'a093ee75-4dc8-4fa6-971a-2c2e3083a300',
    width: 1535,
    height: 890,
  },
  {
    imageName: 'dynamictables10',
    cloudflareImageId: '9386d832-5fe6-4f0b-b7cf-ef30beed9d00',
    width: 1512,
    height: 982,
  },
  {
    imageName: 'dynamictables11',
    cloudflareImageId: '24202ccd-08b1-4fb9-30e0-f1250bace500',
    width: 1530,
    height: 1002,
  },
  {
    imageName: 'c9182280-05fd-4e53-f015-fdea509d1000',
    cloudflareImageId: 'c9182280-05fd-4e53-f015-fdea509d1000',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'f8d8eab7-04a9-4675-c8f5-e21c8a910100',
    cloudflareImageId: 'f8d8eab7-04a9-4675-c8f5-e21c8a910100',
    width: 3024,
    height: 1963,
  },
  {
    imageName: '465d45fe-8dd3-4c5e-7960-e90c0e2a1800',
    cloudflareImageId: '465d45fe-8dd3-4c5e-7960-e90c0e2a1800',
    width: 3024,
    height: 1963,
  },
  {
    imageName: 'd5a92e85-aa21-41ca-6402-6b47a8680300',
    cloudflareImageId: 'd5a92e85-aa21-41ca-6402-6b47a8680300',
    width: 3024,
    height: 1963,
  },
  {
    imageName: 'e60c746d-5561-4cbc-c0e5-5c1326b0bd00',
    cloudflareImageId: 'e60c746d-5561-4cbc-c0e5-5c1326b0bd00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'e6e6b6cf-5893-498b-6df3-201a165abc00',
    cloudflareImageId: 'e6e6b6cf-5893-498b-6df3-201a165abc00',
    width: 1534,
    height: 740,
  },
  {
    imageName: 'eceeccfe-46a9-48b2-05e1-17f8d160f000',
    cloudflareImageId: 'eceeccfe-46a9-48b2-05e1-17f8d160f000',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '6240209c-11fa-4043-c80a-272e182bc500',
    cloudflareImageId: '6240209c-11fa-4043-c80a-272e182bc500',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'e87be9d9-7fab-4ce5-7abb-03d2faed5500',
    cloudflareImageId: 'e87be9d9-7fab-4ce5-7abb-03d2faed5500',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '02a59bc2-59c8-4b36-edb7-d515dd138700',
    cloudflareImageId: '02a59bc2-59c8-4b36-edb7-d515dd138700',
    width: 1922,
    height: 1874,
  },
  {
    imageName: 'b317d251-1749-4db0-6a8f-e694b24bc400',
    cloudflareImageId: 'b317d251-1749-4db0-6a8f-e694b24bc400',
    width: 932,
    height: 360,
  },
  {
    imageName: '6bea2f29-c111-4ac3-9402-dd5411800000',
    cloudflareImageId: '6bea2f29-c111-4ac3-9402-dd5411800000',
    width: 944,
    height: 904,
  },
  {
    imageName: 'b6b696a1-c103-48e6-3c80-cec1aa174100',
    cloudflareImageId: 'b6b696a1-c103-48e6-3c80-cec1aa174100',
    width: 527,
    height: 807,
  },
  {
    imageName: '258b2dc6-df13-48e7-5579-53135bf44300',
    cloudflareImageId: '258b2dc6-df13-48e7-5579-53135bf44300',
    width: 1942,
    height: 1484,
  },
  {
    imageName: '908556b7-121e-4f8a-d948-860185540b00',
    cloudflareImageId: '908556b7-121e-4f8a-d948-860185540b00',
    width: 1932,
    height: 1160,
  },
  {
    imageName: '8d1a3024-4dce-41a3-7061-9fd723000300',
    cloudflareImageId: '8d1a3024-4dce-41a3-7061-9fd723000300',
    width: 936,
    height: 630,
  },
  {
    imageName: '2d2f08b4-cbf6-4914-855b-6dfa97ea2300',
    cloudflareImageId: '2d2f08b4-cbf6-4914-855b-6dfa97ea2300',
    width: 962,
    height: 675,
  },
  {
    imageName: '36252a41-8697-4b0d-f3d4-c889fb1f0b00',
    cloudflareImageId: '36252a41-8697-4b0d-f3d4-c889fb1f0b00',
    width: 942,
    height: 658,
  },
  {
    imageName: 'bd0b4f18-733d-4760-c704-04985af1fa00',
    cloudflareImageId: 'bd0b4f18-733d-4760-c704-04985af1fa00',
    width: 2400,
    height: 1914,
  },
  {
    imageName: '963b16ee-c8c7-45b4-283e-0296507c4400',
    cloudflareImageId: '963b16ee-c8c7-45b4-283e-0296507c4400',
    width: 1218,
    height: 576,
  },
  {
    imageName: '7c633fbb-d0f3-4d10-e4f8-814321adbe00',
    cloudflareImageId: '7c633fbb-d0f3-4d10-e4f8-814321adbe00',
    width: 1208,
    height: 408,
  },
  {
    imageName: '7af1868a-4f7a-411a-395a-fecd58939400',
    cloudflareImageId: '7af1868a-4f7a-411a-395a-fecd58939400',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '932c0074-1c46-4ff8-f3ac-2fb28ffb5b00',
    cloudflareImageId: '932c0074-1c46-4ff8-f3ac-2fb28ffb5b00',
    width: 1069,
    height: 783,
  },
  {
    imageName: 'c1f780bf-fca2-48d3-ab29-b97ea9a5f800',
    cloudflareImageId: 'c1f780bf-fca2-48d3-ab29-b97ea9a5f800',
    width: 1098,
    height: 770,
  },
  {
    imageName: '27ccc39b-4a01-4ca6-9b18-1f24a39e7c00',
    cloudflareImageId: '27ccc39b-4a01-4ca6-9b18-1f24a39e7c00',
    width: 652,
    height: 356,
  },
  {
    imageName: '7db7e7bd-2faa-4900-0024-b36b4ee00c00',
    cloudflareImageId: '7db7e7bd-2faa-4900-0024-b36b4ee00c00',
    width: 1580,
    height: 647,
  },
  {
    imageName: 'f4ee9b7f-4664-48b2-728f-3cabd5d92c00',
    cloudflareImageId: 'f4ee9b7f-4664-48b2-728f-3cabd5d92c00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '7b4214e3-4dfe-4dd5-a95c-6cb9329aa900',
    cloudflareImageId: '7b4214e3-4dfe-4dd5-a95c-6cb9329aa900',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'f933ac96-d66b-44ca-09b8-cea5597eb000',
    cloudflareImageId: 'f933ac96-d66b-44ca-09b8-cea5597eb000',
    width: 3024,
    height: 1964,
  },
  {
    imageName: 'c952905e-c28a-47da-4246-75d9bd0c6600',
    cloudflareImageId: 'c952905e-c28a-47da-4246-75d9bd0c6600',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'sngit1',
    cloudflareImageId: '98c3ff47-028c-4f7e-85f9-9158c10a3300',
    width: 976,
    height: 494,
  },
  {
    imageName: 'sngit2',
    cloudflareImageId: '53ac07c5-a748-43c4-e282-3e42c675ae00',
    width: 1354,
    height: 1237,
  },
  {
    imageName: 'sngit3',
    cloudflareImageId: '0b6c7623-f08d-49b6-e58f-c905f7eb6400',
    width: 1238,
    height: 480,
  },
  {
    imageName: 'sngit4',
    cloudflareImageId: 'a3cbe469-8f4e-462f-c928-34657b2be400',
    width: 1012,
    height: 596,
  },
  {
    imageName: 'sngit5',
    cloudflareImageId: '98a6e43d-2524-4db3-2ac9-6a8272535300',
    width: 1432,
    height: 580,
  },
  {
    imageName: 'sngit6',
    cloudflareImageId: '7db921a3-e426-4ae4-443f-ce0bbbfab900',
    width: 1404,
    height: 542,
  },
  {
    imageName: 'sngit7',
    cloudflareImageId: '4543d55f-e7c4-492f-e43b-de9aeaf48400',
    width: 1244,
    height: 432,
  },
  {
    imageName: 'sngit8',
    cloudflareImageId: '09d44253-2c39-4599-1592-89266c900e00',
    width: 1842,
    height: 674,
  },
  {
    imageName: 'sngit9',
    cloudflareImageId: '65addf5a-a2b0-483e-de12-52dda1ec8500',
    width: 1178,
    height: 426,
  },
  {
    imageName: 'sngit10',
    cloudflareImageId: 'e59aa12c-7aef-4bc9-40d3-2b31f1e8c500',
    width: 1070,
    height: 762,
  },
  {
    imageName: 'sngit11',
    cloudflareImageId: '5bb0b027-8512-46e3-07e0-b70d82228c00',
    width: 1234,
    height: 400,
  },
  {
    imageName: 'sngit12',
    cloudflareImageId: 'b5316eb0-dca8-47d3-afe6-e01b80fc5900',
    width: 2026,
    height: 542,
  },
  {
    imageName: 'sngit13',
    cloudflareImageId: '724917a8-aac4-4173-b397-89721d913f00',
    width: 753,
    height: 634,
  },
  {
    imageName: '0d1c055d-8d56-4cef-32bb-2e4a72849200',
    cloudflareImageId: '0d1c055d-8d56-4cef-32bb-2e4a72849200',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'dbtworkflows1.1',
    cloudflareImageId: 'a6f1dc1c-a5f8-4fbd-6f42-f32b77b90700',
    width: 1974,
    height: 904,
  },
  {
    imageName: 'dbtworkflows1.2',
    cloudflareImageId: '861e8473-b9d1-4f42-6cee-a876ed0cb000',
    width: 1948,
    height: 628,
  },
  {
    imageName: 'dbtworkflows1.3',
    cloudflareImageId: '826951e9-d74f-424b-4260-d23d828b0f00',
    width: 1188,
    height: 650,
  },
  {
    imageName: 'dbtworkflows2.1',
    cloudflareImageId: '9932828d-90ae-41a6-dfdb-dd299d38c400',
    width: 1948,
    height: 628,
  },
  {
    imageName: 'dbtworkflows2.2',
    cloudflareImageId: '5137727a-8b05-48f8-f219-ad78c5deea00',
    width: 2196,
    height: 618,
  },
  {
    imageName: 'dbtworkflows2.3',
    cloudflareImageId: '9f0c1232-6f33-4171-0789-f2fb249da400',
    width: 1616,
    height: 728,
  },
  {
    imageName: 'dbtworkflows3.1',
    cloudflareImageId: '37730b3d-c994-4aba-47a2-60765cee3b00',
    width: 1948,
    height: 628,
  },
  {
    imageName: 'dbtworkflows3.2',
    cloudflareImageId: 'e46f23c8-d744-46c5-79d4-982e378c6700',
    width: 1544,
    height: 772,
  },
  {
    imageName: 'dbtworkflows3.3',
    cloudflareImageId: '498fc369-c786-4ec6-8d06-9355dac86f00',
    width: 1148,
    height: 574,
  },
  {
    imageName: 'dbtworkflows3.4',
    cloudflareImageId: '7c574469-1179-48a1-0b0c-b3a006566800',
    width: 1148,
    height: 574,
  },
  {
    imageName: '5727f9e2-2661-4175-2fe6-8b62c3986400',
    cloudflareImageId: '5727f9e2-2661-4175-2fe6-8b62c3986400',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'eaf432bb-1014-4a04-6ef2-225f886a6a00',
    cloudflareImageId: 'eaf432bb-1014-4a04-6ef2-225f886a6a00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'e330a4cc-281f-4749-19d3-54e3aa1ce200',
    cloudflareImageId: 'e330a4cc-281f-4749-19d3-54e3aa1ce200',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'bb4544c0-4693-4e07-28cd-924c34a04500',
    cloudflareImageId: 'bb4544c0-4693-4e07-28cd-924c34a04500',
    width: 1920,
    height: 1080,
  },
  {
    imageName: '1a9055a4-7b4f-49c9-15c9-d943a7faca00',
    cloudflareImageId: '1a9055a4-7b4f-49c9-15c9-d943a7faca00',
    width: 1920,
    height: 1080,
  },
  {
    imageName: 'rolesAndEntities',
    cloudflareImageId: 'adf5d920-7b94-49f3-e2a4-a493adefc400',
    width: 2100,
    height: 884,
  },
]

export const cloudflareImages = _cloudflareImages.reduce((acc, image) => {
  if (acc[image.imageName]) {
    throw new Error(`Duplicate key found: ${image.imageName}`)
  }
  return {
    ...acc,
    [image.imageName]: image,
  }
}, {} as Record<string, CloudflareImage>)

// Used classNames so Tailwind compiles them
const _classNames =
  'md:w-1/5 md:w-1/4 md:w-2/3 w-2/3 md:w-1/3 w-1/3 md:w-4/5 w-4/5 rounded-xl shadow-2xl ring-2 ring-white/20 my-4'

type MarkdocImageProps = {
  imageName: string
  alt: string
  className?: string
  imgClassName?: string
  priority?: boolean
}
export function MarkdocImage({
  imageName,
  alt,
  className,
  imgClassName,
  priority = false,
}: MarkdocImageProps) {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
  }

  // Handle escape key press to exit fullscreen mode
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        setIsFullscreen(false)
      }
    }

    // Add event listener for keydown
    document.addEventListener('keydown', handleEscape)

    // Clean up the event listener when component unmounts or isFullscreen changes
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isFullscreen])

  return (
    <div
      className={`not-prose flex items-center justify-center ${className} ${
        isFullscreen
          ? 'fixed inset-0 z-50 cursor-zoom-out bg-slate-900 bg-opacity-90 p-6 lg:p-12 xl:p-20'
          : 'cursor-zoom-in'
      }`}
      onClick={toggleFullscreen}
    >
      <Image
        priority={priority}
        src={cloudflareImages[imageName].cloudflareImageId}
        width={cloudflareImages[imageName].width}
        height={cloudflareImages[imageName].height}
        alt={alt}
        className={`transition-all duration-300 ease-in-out ${
          isFullscreen
            ? 'max-h-full max-w-full object-contain' // Center image with padding
            : `mx-auto ${imgClassName}`
        }`}
        sizes="100vw" // this causes NextJS to load different sized images from Cloudflare
      />
    </div>
  )
}

// Cloudflare can't handle most of our gifs, so we use Google Cloud Storage for them
type GoogleCloudImage = {
  imageName: string
  filename: string
  width: number
  height: number
}
const _googleCloudImages: GoogleCloudImage[] = [
  {
    imageName: 'optimizationPresentationOverview',
    filename: 'blog/optimization-presentation-overview.gif',
    width: 1272,
    height: 704,
  },
  {
    imageName: 'nestedViewsGif',
    filename: 'blog/nested_views.gif',
    width: 1512,
    height: 976,
  },
  // changelog
  {
    imageName: 'sliceByMetric',
    filename: 'changelog/slice_by_metric_20230501.gif',
    width: 1202,
    height: 410,
  },
  {
    imageName: 'sliceByAgg',
    filename: 'changelog/slice_by_agg_20230501.gif',
    width: 1184,
    height: 408,
  },
  {
    imageName: 'addedChartLinks',
    filename: 'changelog/added_chart_links_20230301.gif',
    width: 1542,
    height: 1190,
  },
  {
    imageName: 'workloadChange',
    filename: 'changelog/workload_change_20230215.gif',
    width: 1542,
    height: 1190,
  },
  {
    imageName: 'lookerDashboard',
    filename: 'changelog/looker_dashboard_20230508.gif',
    width: 1268,
    height: 962,
  },
  {
    imageName: 'dateRangeDefaults',
    filename: 'changelog/date_range_defaults_20230224.gif',
    width: 1280,
    height: 936,
  },
  {
    imageName: 'customWorkloads',
    filename: 'changelog/custom_workloads_20230517.gif',
    width: 1594,
    height: 950,
  },
  {
    imageName: 'sortableTables',
    filename: 'changelog/sortable_tables_20230411.gif',
    width: 1450,
    height: 966,
  },
  {
    imageName: 'dropdownSearch',
    filename: 'changelog/dropdown_search_20230405.gif',
    width: 1068,
    height: 718,
  },
  {
    imageName: 'dbtHistory',
    filename: 'changelog/dbt_history_20230221.gif',
    width: 1614,
    height: 1188,
  },
]

export const googleCloudImages = _googleCloudImages.reduce((acc, image) => {
  if (acc[image.imageName]) {
    throw new Error(`Duplicate key found: ${image.imageName}`)
  }
  return {
    ...acc,
    [image.imageName]: image,
  }
}, {} as Record<string, GoogleCloudImage>)

type RemoteImageProps = {
  imageName: string
  alt: string
  divClassName?: string
  imgClassName?: string
  priority?: boolean
}
export function RemoteImage({
  imageName,
  alt,
  divClassName = '',
  imgClassName = '',
  priority = false,
}: RemoteImageProps) {
  return (
    <div className={clsx(`not-prose flex justify-center`)}>
      <div className={divClassName}>
        <Image
          src={`https://storage.googleapis.com/prod_select_images/${googleCloudImages[imageName].filename}`}
          alt={alt}
          width={googleCloudImages[imageName].width}
          height={googleCloudImages[imageName].height}
          className={`mx-auto ${imgClassName}`}
          priority={priority}
          unoptimized // required to force NextJS to not use the custom cloudflare loader
        />
      </div>
    </div>
  )
}
